var _view, _path, _g, _view2, _path2, _circle, _path3, _path4, _view3, _path5, _g2, _view4, _path6, _g3, _view5, _path7, _g4, _view6, _path8, _g5, _view7, _path9, _g6, _view8, _path10, _g7, _view9, _path11, _g8, _view10, _path12, _circle2, _view11, _path13, _g9, _view12, _path14, _g10, _view13, _path15, _g11, _view14, _path16, _circle3, _path17, _path18, _view15, _path19, _g12, _view16, _path20, _path21, _path22, _path23, _path24, _view17, _g13, _view18, _circle4, _path25, _path26, _view19, _circle5, _path27, _ellipse, _path28, _path29, _view20, _g14, _view21, _g15, _view22, _circle6, _view23, _g16, _view24, _g17, _view25, _g18, _view26, _path30, _path31, _path32, _view27, _circle7, _circle8, _path33, _path34, _path35, _path36, _path37, _g19, _path38, _path39, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _view28, _g20, _view29, _circle9, _circle10, _circle11, _path40, _path41, _circle12, _path42, _path43, _view30, _g21, _view31, _circle13, _path44, _path45, _view32, _g22, _view33, _circle14, _circle15, _view34, _circle16, _view35, _path46, _view36, _circle17, _view37, _path47, _view38, _circle18, _view39, _path48, _view40, _circle19, _view41, _path49, _view42, _circle20, _view43, _path50, _view44, _circle21, _view45, _path51, _view46, _circle22, _view47, _path52, _view48, _circle23, _view49, _path53, _view50, _circle24, _view51, _path54, _view52, _circle25, _view53, _path55, _view54, _circle26, _view55, _path56, _view56, _circle27, _view57, _path57, _view58, _path58, _view59, _path59, _view60, _rect, _path60, _view61, _rect2, _view62, _path61, _path62, _path63, _path64, _view63, _path65, _path66, _path67, _path68, _view64, _defs, _g23, _g24, _view65, _path69, _path70;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4748,
    height: 3540,
    viewBox: "0 0 4748 3540",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _view || (_view = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_barrel",
    viewBox: "0 600 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    y: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.83 193.848c-20.633-35.83-38.57-67.264-39.858-69.852-2.847-5.715-5.747-14.384-7.043-21.055-5.651-29.074 3.857-58.853 25.286-79.185C40.242 11.395 56.294 3.532 74.128.776c6.08-.94 19.306-.927 25.088.023 5.846.961 13.254 2.925 18.05 4.785 38.708 15.018 61.4 55.158 54.197 95.874-1.395 7.888-4.178 16.367-7.635 23.263-2.006 4.002-76.97 134.271-77.267 134.271-.119 0-17.097-29.315-37.73-65.145z",
    fill: "#6b6051",
    stroke: "#000",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.475 0 0 7.49086 -383.662 -1368.123)",
    strokeWidth: 0.16,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.971,
    cy: 194.204,
    r: 10,
    fill: "#8e806b",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.563 189.905v7.739s4.36 2.315 7.342 2.315c2.91 0 7.375-1.885 7.375-1.885v-8.269s-3.407-2.513-7.475-2.348c-4.068.166-7.242 2.448-7.242 2.448z",
    fill: "#907b57",
    stroke: "#7d5b3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.624 195.943s5.01 1.266 7.689 1.233c2.712-.033 6.88-1.398 6.88-1.398l.003-1.423s-4.682.373-6.98.422c-2.498.054-6.265-.305-7.586-.416zM55.604 191.037s4.968-1.24 7.647-1.208c2.712.033 6.93 1.366 6.93 1.366l.003 1.414s-4.658-.373-6.955-.422c-2.498-.054-6.257.305-7.578.416z",
    fill: "#906d57",
    stroke: "#7d5b3e"
  })))), _view2 || (_view2 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_bed",
    viewBox: "1000 0 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    x: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 193.898c-20.546-35.793-38.407-67.194-39.69-69.78-2.835-5.709-5.723-14.369-7.014-21.033-5.627-29.044 3.842-58.792 25.18-79.104C40.198 11.633 56.182 3.779 73.942 1.025c6.054-.938 19.224-.926 24.982.023 5.822.96 13.199 2.922 17.973 4.78 38.547 15.003 61.142 55.102 53.97 95.775-1.39 7.881-4.16 16.35-7.603 23.24-1.998 3.998-76.646 134.134-76.942 134.134-.118 0-17.025-29.286-37.572-65.079z",
    fill: "#3e467d",
    stroke: "#242949",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.287,
    cy: 140.403,
    r: 10,
    fill: "#5c66ae",
    stroke: "#242949",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    transform: "matrix(7.475 0 0 7.49086 -379.57 -966.268)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.685 39.994h-8.493l-.131 85.7h8.957l.263-9.614h83.7l-.198 9.497h7.871l.164-9.642h9.798v-12.527H39.14z",
    fill: "#e78d16",
    stroke: "#513208",
    strokeWidth: 2.143
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.353 83.482h92.042v15.244H44.353zm-1.58-15.895C54.097 78.4 61.471 81.56 79.248 79.867c1.12-.107-1.449-8.958-15.077-13.746-16.883-5.931-21.398 1.466-21.398 1.466z",
    fill: "#b0b0b0",
    stroke: "#717171",
    strokeWidth: 2.096
  }))), _view3 || (_view3 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_cache",
    viewBox: "1653.4 0 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    x: 1653.4,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.83 193.848c-20.633-35.83-38.57-67.264-39.858-69.852-2.847-5.715-5.747-14.384-7.043-21.055-5.651-29.074 3.857-58.853 25.286-79.185C40.242 11.395 56.294 3.532 74.128.776c6.08-.94 19.306-.927 25.088.023 5.846.961 13.254 2.925 18.05 4.785 38.708 15.018 61.4 55.158 54.197 95.874-1.395 7.888-4.178 16.367-7.635 23.263-2.006 4.002-76.97 134.271-77.267 134.271-.119 0-17.097-29.315-37.73-65.145z",
    fill: "#6d5553",
    stroke: "#000",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.66218 0 0 7.66216 8.997 7.145)",
    strokeWidth: 0.131
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.186,
    cy: 10.186,
    r: 9.829,
    fill: "#aa8481",
    stroke: "#b4b4b4",
    strokeWidth: 0.173,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.976 13.93l1.894 1.914-.943.917-1.206-1.234-.73.71.945.956-1.1 1.06-1.24-1.294.594-.577-.421-.447s-.429.378-.624.558c-.717-.138-.79-.758-.79-.758l9.039-8.74c-.524-.526-.84-1.074-.962-1.716-.12-.637-.074-1.545.69-2.247.98-.9 2.78-.718 4.14.219 1.359.936 1.926 2.723 1.481 3.688-.445.965-1.64 1.362-2.42 1.355-.747-.006-1.343-.046-2.045-.536z",
    fill: "#819eaa",
    stroke: "#000",
    strokeWidth: 0.138
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.779,
    cy: -2.428,
    rx: 2.456,
    ry: 1.595,
    transform: "matrix(.87657 .48128 -.33504 .9422 0 0)",
    fill: "#aa8481",
    stroke: "#000",
    strokeWidth: 0.139,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.283 7.747c-.732-.052-.892-.757-.892-.757m-5.427 6.937c-.732-.052-.893-.758-.893-.758",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.138
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.743 15.928l2.22-2.02",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.069
  })))), _view4 || (_view4 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_clothes",
    viewBox: "2306.8 0 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    x: 2306.8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.496 193.157c-20.836-36.25-38.645-67.443-39.575-69.316-2.121-4.274-5.546-14.563-6.63-19.918-5.847-28.892 3.68-59.225 24.977-79.522C48.206 4.447 77.204-3.732 105.113 2.446c34.029 7.532 60.522 35.421 66.396 69.894 1.177 6.906 1.398 19.28.468 26.124-1.656 12.17-5.266 21.797-13.765 36.7-20.658 36.227-71.266 123.896-71.523 123.9-.168.001-17.355-29.656-38.192-65.907z",
    fill: "#836b8e",
    stroke: "#3e457d",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.7254 0 0 7.7247 -401.58 -2036.335)",
    strokeWidth: 0.129
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.236,
    cy: 274.646,
    r: 10,
    fill: "#836b8e",
    stroke: "#3e457d",
    strokeWidth: 0.194,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.31 283.222l-7.39-11.197s-1.124-2.48-.628-2.778c.496-.298 2.315 1.852 2.315 1.852l7.281 10.967z",
    fill: "#565656",
    stroke: "#7e7e7e",
    strokeWidth: 0.026,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -96.832,
    cy: 262.796,
    rx: 0.488,
    ry: 2.433,
    transform: "rotate(-33.167)",
    fill: "#8456b2",
    stroke: "#7e7e7e",
    strokeWidth: 0.026,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.826 284.14c1.754-5.822-2.66-11.835-2.81-8.26-.15 3.574 3.02.482 3.236-.886.23-1.45 1.61-2.395 1.61-2.395",
    fill: "none",
    stroke: "#b29b56",
    strokeWidth: 0.595,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.379 272.25c2.415-1.618 3.993-2.03 4.903-1.905.785.107 2.958 1.41 4.294.844",
    fill: "none",
    stroke: "#b29b56",
    strokeWidth: 0.595
  })))), _view5 || (_view5 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_death_store",
    viewBox: "0 1580 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    y: 1580,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.321 193.004C27.459 156.758 9.629 125.57 8.698 123.698c-2.123-4.274-5.552-14.562-6.637-19.916-5.855-28.888 3.683-59.218 25.006-79.512C48.029 4.32 77.062-3.858 105.004 2.318c34.069 7.531 60.593 35.417 66.475 69.885 1.178 6.905 1.4 19.278.467 26.12-1.657 12.169-5.272 21.795-13.78 36.696-20.683 36.222-71.35 123.88-71.608 123.883-.169.002-17.375-29.652-38.237-65.898z",
    fillOpacity: 0.988,
    stroke: "#fff",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.725 0 0 7.741 -389.735 -796.78)",
    strokeWidth: 0.194,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.739,
    cy: 114.124,
    r: 10,
    fill: "#000005",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.407 113.852l1.774-5.258 5.335 1.605-1.852 5.358z",
    fill: "#fff",
    stroke: "#888"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -48.958,
    cy: -116.491,
    rx: 0.457,
    ry: 0.474,
    transform: "rotate(174.497)",
    stroke: "#000004"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -47.03,
    cy: -117.234,
    rx: 0.457,
    ry: 0.474,
    transform: "rotate(174.497)",
    stroke: "#000004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.384 108.418l2.315-1.216 5.543 1.567-2.082 5.612-2.243 1.15 1.869-5.476z",
    fill: "#fff",
    stroke: "#888"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -80.938,
    cy: -95.13,
    rx: 0.457,
    ry: 0.234,
    transform: "rotate(-168.955)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -78.703,
    cy: -94.911,
    rx: 0.457,
    ry: 0.234,
    transform: "rotate(-168.955)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.768 110.09l2.421-1.31",
    fill: "#000005",
    stroke: "#888"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -45.033,
    cy: -117.963,
    rx: 0.457,
    ry: 0.474,
    transform: "rotate(174.497)",
    stroke: "#000004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.795 115.84l4.256-4.64 4.465 4.943-4.379 4.754z",
    fill: "#fff",
    stroke: "#888"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -114.106,
    cy: 60.93,
    rx: 0.668,
    ry: 0.487,
    transform: "rotate(-90.555)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -119.39,
    cy: 60.955,
    rx: 0.668,
    ry: 0.487,
    transform: "rotate(-90.555)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -116.671,
    cy: 63.373,
    rx: 0.668,
    ry: 0.487,
    transform: "rotate(-90.555)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -116.446,
    cy: 58.374,
    rx: 0.668,
    ry: 0.487,
    transform: "rotate(-90.555)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.295 111.165l4.523-.088 4.236 4.772-4.344.135z",
    fill: "#fff",
    stroke: "#888"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -103.16,
    cy: -83.745,
    rx: 0.668,
    ry: 0.487,
    transform: "rotate(-159.351)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -101.547,
    cy: -81.538,
    rx: 0.668,
    ry: 0.487,
    transform: "rotate(-159.351)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.767 116.217l4.245-.128-4.098 4.704-4.567.195z",
    fill: "#fff",
    stroke: "#888"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.816,
    cy: -136.445,
    rx: 0.489,
    ry: 0.275,
    transform: "rotate(145.24)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.986,
    cy: -135.983,
    rx: 0.489,
    ry: 0.275,
    transform: "rotate(145.24)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.093,
    cy: -135.546,
    rx: 0.489,
    ry: 0.275,
    transform: "rotate(145.24)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.608,
    cy: -134.898,
    rx: 0.489,
    ry: 0.275,
    transform: "rotate(145.24)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.506,
    cy: -135.312,
    rx: 0.489,
    ry: 0.275,
    transform: "rotate(145.24)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.852,
    cy: -134.426,
    rx: 0.489,
    ry: 0.275,
    transform: "rotate(145.24)",
    stroke: "#000"
  })))), _view6 || (_view6 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_grocery",
    viewBox: "653.4 1580 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    x: 653.4,
    y: 1580,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.359 193.102c-20.867-36.253-38.7-67.448-39.631-69.32-2.124-4.275-5.554-14.565-6.64-19.92-5.855-28.895 3.685-59.23 25.012-79.528C48.067 4.378 77.106-3.8 105.054 2.378c34.076 7.532 60.606 35.423 66.488 69.899 1.179 6.906 1.4 19.281.468 26.125-1.657 12.17-5.273 21.799-13.783 36.703-20.687 36.23-71.366 123.904-71.623 123.908-.169.002-17.38-29.658-38.245-65.911z",
    fill: "#e4a053",
    stroke: "#777",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.43218 0 0 7.49056 -381.918 -1569.718)",
    strokeWidth: 0.134,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.291,
    cy: 221.392,
    r: 10,
    fill: "#b27a3c",
    stroke: "#fff",
    strokeWidth: 0.201
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.98 221.373c-.209 1.5 1.076 3.063 2.48 3.812 1.403.748 3.434 1.086 5.261 1.005 2.105-.093 5.847-.701 6.408-1.005.562-.304 2.877-1.59 2.76-3.158-.117-1.566-.117-2.76-1.45-3.39-1.359-.644-4.794-1.17-6.852-1.076-1.815.082-4.093.584-5.332.959-1.24.374-3.074 1.419-3.274 2.853zm8.752-.595",
    fill: "#c97837",
    stroke: "#b06328",
    strokeWidth: 0.054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.256 218.08c.455 1.888.25 3.411.042 4.51.823-.841 1.5-1.739 1.656-2.742.172-1.104.175-2.1.175-2.1zM57.378 218.94c.587 1.772.53 2.634.538 3.684.492-.644.955-1.839 1.11-2.842.172-1.104-.023-1.356-.023-1.356zM63.269 217.686c.058 2.02-.028 3.378-.484 4.56.823-.842 1.665-1.656 1.959-2.627.205-.675.365-1.984.365-1.984zm2.941.102c.058 2.02-.14 2.595-.62 4.215.897-.717 1.637-1.37 1.987-2.323.254-.69.415-1.654.415-1.654zm2.794.505c-.313 1.961-.676 2.832-1.132 4.014 1.096-.61 1.533-1.296 1.842-1.833.3-.52.593-1.799.593-1.799z",
    fill: "#f28a39",
    stroke: "#b06328",
    strokeWidth: 0.027
  })))), _view7 || (_view7 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_music",
    viewBox: "1306.8 1580 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    x: 1306.8,
    y: 1580,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.83 193.848c-20.633-35.83-38.57-67.264-39.858-69.852-2.847-5.715-5.747-14.384-7.043-21.055-5.651-29.074 3.857-58.853 25.286-79.185C40.242 11.395 56.294 3.532 74.128.776c6.08-.94 19.306-.927 25.088.023 5.846.961 13.254 2.925 18.05 4.785 38.708 15.018 61.4 55.158 54.197 95.874-1.395 7.888-4.178 16.367-7.635 23.263-2.006 4.002-76.97 134.271-77.267 134.271-.119 0-17.097-29.315-37.73-65.145z",
    fill: "#b092ae",
    stroke: "#577190",
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.475 0 0 7.49086 -387.27 -2171.422)",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.455,
    cy: 301.384,
    r: 10,
    fill: "#b092ae",
    stroke: "#577190",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.241 299.697c.218.434.412.724.535 1.127.324-.124.638-.212.832-.259-.105-.427-.539-1.195-.749-1.48",
    fill: "#dbdbdb",
    stroke: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.583 306.144c-.072.519-.457 1.32-.604 1.754-.305.895-.617 1.054-1.073 1.438-.28.237-1.4.489-2.244.226-.693-.217-.878-.826-.878-.826s.276.095.42.108c.16.014.48-.036.48-.036.277-.162.368-.199.484-.438a.91.91 0 00.1-.308c.02-.13-.048-.426-.105-.58-.063-.17-.303-.363-.547-.468-.243-.104-.693-.067-.929.103-.3.216-.428.335-.552.803-.08.298-.092.795.141 1.22.569 1.033 1.695 1.28 2.991 1.1 1.093-.153 1.629-.753 1.983-1.236.298-.408.494-.932.691-1.467.221-.6.337-.988.458-1.556m-1.336-4.445c.269.67.603 2.931.663 3.635.4-.099.543-.237.835-.33-.06-.468-.11-1.204-.244-2.03-.14-.87-.244-1.109-.336-1.435m-1.768-3.49c-.141-.34-.366-.81-.474-1.121-.086-.248-.332-.895-.392-1.171-.07-.316-.1-.819.377-1.278.262-.252 1.07-.658 1.575.082.505.74.21 1.503.1 1.845-.135.416-.631 1.042-1.009 1.421-.36.363-.582.611-1.173 1.087-1.013.817-2.893 2.274-3.133 3.773-.199 1.243.242 1.872.648 2.414.407.544 1.211 1.363 3.659 1.363 2.187-.05 3.231-.794 3.878-1.54.77-.886.716-2.877-.167-3.684-1.368-1.25-3.934-.267-4.559.465-.686.803-.649 1.54-.313 2.076.337.537 1.585.836 1.666.53.088-.337-1.233-.399-.96-1.691.1-.466.535-.697.818-.798.295-.106.903-.324 1.492-.334 1.009-.017 1.573.486 1.703 1.367.118.8-.266 1.132-.799 1.741-.541.619-2.431 1.128-3.407.884-.903-.226-2.421-.466-2.582-1.943-.12-1.099 1.147-2.022 1.591-2.398.66-.558 1.988-1.551 2.7-2.402.619-.738.75-1.264.901-1.832.19-.707.046-1.752-.216-2.424-.169-.433-.557-1.058-1.669-1.052-1.354.006-1.833 1.146-1.869 1.982-.022.521.119.894.261 1.33.12.369.201.658.33 1.007.102.276.193.563.342.871",
    fill: "#dbdbdb",
    stroke: "#9f9f9f"
  })))), _view8 || (_view8 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_pharmacy",
    viewBox: "1960.1999999999998 1580 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    x: 1960.1999999999998,
    y: 1580,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 193.898c-20.546-35.793-38.407-67.194-39.69-69.78-2.835-5.709-5.723-14.369-7.014-21.033-5.627-29.044 3.842-58.792 25.18-79.104C40.198 11.633 56.182 3.779 73.942 1.025c6.054-.938 19.224-.926 24.982.023 5.822.96 13.199 2.922 17.973 4.78 38.547 15.003 61.142 55.102 53.97 95.775-1.39 7.881-4.16 16.35-7.603 23.24-1.998 3.998-76.646 134.134-76.942 134.134-.118 0-17.025-29.286-37.572-65.079z",
    fill: "#eecd90",
    stroke: "#603a16",
    strokeWidth: 2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.475 0 0 7.49086 -379.57 -966.268)",
    strokeWidth: 0.134,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.287,
    cy: 140.403,
    r: 10,
    fill: "#eecd90",
    stroke: "#603a16",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.602 146.68l1.718 1.427s4.525-4.14 4.483-4.603c-.427-.528-1.603-1.64-1.603-1.64-2.437 2.258-2.757 2.923-4.598 4.815z",
    fill: "#dcb874",
    stroke: "#8e806b",
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42.165 147.911a3.24 2.17 0 01-3.179 2.008 3.24 2.17 0 01-3.273-1.939",
    transform: "matrix(.7086 -.7056 .63976 .76858 0 0)",
    fill: "#dcb874",
    stroke: "#8e806b",
    strokeWidth: 0.156
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -63.048,
    cy: 144.779,
    rx: 3.359,
    ry: 2.07,
    transform: "matrix(.70163 -.71254 .72679 .68686 0 0)",
    fill: "#dcb874",
    stroke: "#8e806b",
    strokeWidth: 0.155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.669 145.955l2.67-3.166",
    fill: "#8e806b",
    stroke: "#c99e44",
    strokeWidth: 0.227
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.92 136.714l.899 2.667 7.659-2.838-.755-2.397c-4.028.142-5.225 1.7-7.802 2.568z",
    fill: "#b29b56",
    stroke: "#8e806b",
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.437 136.415a4.068 2.595-22.141 01-1.21 2.86 4.068 2.595-22.141 01-3.822 1.418 4.068 2.595-22.141 01-2.591-1.45",
    fill: "#b29b56",
    stroke: "#8e806b",
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.133,
    cy: 149.174,
    rx: 4.123,
    ry: 2.595,
    transform: "rotate(-22.141)",
    fill: "#b29b56",
    stroke: "#8e806b",
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.003 136.536l5.617-2.324",
    fill: "#b29b56",
    stroke: "#988c68",
    strokeWidth: 0.107
  })))), _view9 || (_view9 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_playground",
    viewBox: "2960.2000000000003 0 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    x: 2960.2000000000003,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.359 193.102c-20.867-36.253-38.7-67.448-39.631-69.32-2.124-4.275-5.554-14.565-6.64-19.92-5.855-28.895 3.685-59.23 25.012-79.528C48.067 4.378 77.106-3.8 105.054 2.378c34.076 7.532 60.606 35.423 66.488 69.899 1.179 6.906 1.4 19.281.468 26.125-1.657 12.17-5.273 21.799-13.783 36.703-20.687 36.23-71.366 123.904-71.623 123.908-.169.002-17.38-29.658-38.245-65.911z",
    fill: "#b46858",
    stroke: "#512370",
    strokeWidth: 2
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.39117 0 0 8.39147 .097 -.894)",
    strokeWidth: 0.119
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.319,
    cy: 10.319,
    r: 8.943,
    fill: "none",
    stroke: "#421d5c",
    strokeWidth: 0.315,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.643 12.84c-.294-.651-.823-.487-1.248-.261-.566.3-1.323 1.99-1.636 2.312-.313.323-.622.964-1.223 1.426-.478.368-1.324-.04-1.632-.612-.194-.359-.138-1.15.457-1.857a69.88 69.88 0 001.578-1.932c.356-.457.855-.949 1.186-1.795.331-.847.96-1.65.83-2.015-.096-.273-1.274-.23-2.05.213-.713.405-1.208 1.562-1.95 1.537-.713-.024-1.45-.896-.899-1.64.553-.744.992-1.083 1.607-1.343.698-.294 1.28-.542 2.192-.648.876-.101 1.609-.121 1.968-.01.481.15 1.197.165 1.473-.183.397-.5-.424-.847-.456-1.712-.032-.866 1.014-1.844 1.888-1.845.874-.001 1.848.462 2.247.933.4.472.687 1.088.651 1.814-.036.726-.183 1.021-.746 1.321-.596.318-1.13-.337-1.583.552-.148.289.308.704.922 1.196.628.502 1.555 1.07 1.99 1.577.486.567.84 1.602.623 2.294-.218.692-1.097 1.226-1.657.597-.559-.628-.688-1.928-1.25-2.553-.5-.554-.686-.595-1.006-.127-.32.468-.559 1.278-.411 1.94.148.661.277 1.586.205 2.18-.072.594-.224 1.961-.482 2.546-.313.708-.734 1.532-1.623 1.546-.878.014-1.175-1.277-.954-1.919.176-.51.189-.79.746-1.723.293-.49.537-1.157.243-1.809z",
    fill: "none",
    stroke: "#392e3f",
    strokeWidth: 0.252
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.916 13.164c1.962.781 2.014 1.467 2.014 1.467m1.972.893c1.762-.145 2.421.79 2.421.79m-1.588-3.288c.957-1.154 1.776-.555 1.776-.555m-5.645-.412c.495-.268 1.58-1.176 2.185-.682.606.494.822.984.822.984M8.542 9.162c1.217 1.719 1.027 1.824 1.778 1.393.752-.43 1.198-.829 1.448-.579s.648.86.648.86M5.022 7.203c.517.146.977 1.9.977 1.9m10.376.945c-.182-.048-.765-.23-1.008.026-.242.256-.784 1.457-.784 1.457M8.895 8.116c.54-.178 1.2-.106 1.554-.562.354-.455.522-1.256.522-1.256m.918.132c.235.754 1.352.655 1.352.655m-.628 2.323c-.12-1.115 1.005-1.484 1.005-1.484",
    fill: "none",
    stroke: "#303030",
    strokeWidth: 0.012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.525 7.458c.957.441 1.095.77.991 1.335-.104.564.227 1.173.227 1.173",
    fill: "none",
    stroke: "#303030",
    strokeWidth: 0.012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86 14.353a2.329 2.329 0 00-.383-.4 4.867 4.867 0 00-.522-.354 9.542 9.542 0 00-.855-.42 7.149 7.149 0 01.24-.3c.133-.164.34-.42.46-.572.198-.25.228-.28.314-.336a8.25 8.25 0 01.77-.458c.327-.165.515-.222.735-.222.198 0 .287.036.463.183.22.185.45.44.608.678l.083.124-.102.034a2.08 2.08 0 00-.416.199c-.163.11-.37.347-.589.676-.163.244-.244.377-.515.84a24.082 24.082 0 01-.234.397c-.004.004-.03-.026-.057-.068zm7.793-1.46c-.352-.077-.583-.395-.892-1.23l-.083-.222.202-.409c.379-.765.501-.95.67-1.009.09-.03.376-.029.528.005l.108.024.086.127c.099.146.242.427.307.605.203.55.237 1.046.096 1.41-.119.307-.416.591-.71.679a.853.853 0 01-.312.02zM6.009 8.95c-.001-.037-.182-.575-.261-.773-.148-.374-.33-.707-.47-.857a.77.77 0 01-.058-.066c0-.009.23-.134.337-.183.365-.17.973-.406 1.269-.495.598-.18 1.295-.275 2.121-.29.56-.01.602-.004 1.1.134.23.064.843-.082.903-.082.017 0-.11.252-.11.256 0 .004-.029.094-.064.2-.117.357-.317.705-.485.846-.098.083-.27.17-.424.213a5.11 5.11 0 01-.362.077c-.137.024-.29.053-.341.064l-.093.02-.055-.051a.435.435 0 00-.225-.116c-.266-.073-.712-.053-1.155.051-.48.113-.855.3-1.164.58-.082.074-.352.36-.437.462-.021.026-.026.028-.027.01z",
    fill: "#917e47",
    stroke: "#303030",
    strokeWidth: 0.0119061,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.784 9.694a1.115 1.115 0 01-.572-.374c-.222-.274-.272-.61-.132-.887.077-.152.398-.544.633-.773.16-.155.38-.336.412-.336a.27.27 0 01.078.07c.22.254.452.76.66 1.435l.069.227-.088.097c-.282.313-.5.482-.7.54a.873.873 0 01-.36.001zm4.979 1.01c-.054-.015-.176-.129-.264-.245a29.02 29.02 0 01-.396-.575 52.327 52.327 0 00-.37-.541c-.024-.033-.042-.068-.04-.077.002-.008.054-.11.115-.226.213-.405.293-.625.295-.816 0-.1.004-.11.027-.117a16.798 16.798 0 01.311-.057c.594-.106.756-.172.983-.4l.125-.124.185.096c.254.131.384.22.52.356.218.216.273.418.214.77a1.97 1.97 0 00.001.566c.023.134.088.365.133.467l.025.06h-.038c-.154 0-.368.102-.864.408-.426.262-.696.413-.799.445-.088.027-.103.028-.163.01zm-3.787 5.608a1.372 1.372 0 01-.534-.218c-.18-.122-.39-.366-.45-.521-.133-.358-.009-.94.3-1.407.048-.07.232-.303.409-.516l.322-.386.104.044c.472.201.895.435 1.203.664.149.111.363.326.44.442a.594.594 0 01.069.122c0 .028-.116.19-.224.314a7.18 7.18 0 00-.295.383c-.347.48-.522.684-.752.881-.147.127-.244.18-.37.2a.551.551 0 01-.222-.002zm6.21-.219c-.428-.394-1.126-.631-1.858-.631h-.213l.09-.181c.093-.186.146-.28.287-.522.204-.346.33-.66.386-.95.044-.232.039-.529-.012-.729-.023-.09-.023-.092 0-.125.066-.092.333-.315.489-.408.314-.187.676-.226.984-.104.13.051.125.04.16.267.072.467.1.834.092 1.187-.007.26-.051.662-.143 1.287-.061.42-.166.978-.183.977a.639.639 0 01-.08-.068zm.622-9.014a2.099 2.099 0 01-.45-.137c-.146-.056-.228-.163-.424-.349l-.528-.5.038-.27a.792.792 0 00-.017-.317 1.503 1.503 0 00-.176-.386c-.063-.088-.188-.455-.224-.59-.02-.079-.04-.101-.045-.22-.011-.276.094-.568.312-.864.094-.127.367-.396.493-.485.22-.155.421-.251.652-.312a.973.973 0 01.308-.034c.427 0 .884.11 1.331.322.53.252.833.527 1.096.992.232.41.334.824.315 1.272-.021.492-.095.738-.279.935-.142.153-.408.317-.567.35-.069.014-.107.013-.596-.01-.195-.008-.285.005-.409.061a.95.95 0 00-.415.412l-.046.082-.048.077a3.122 3.122 0 01-.261-.025z",
    fill: "#917b56",
    stroke: "#303030",
    strokeWidth: 0.0119061,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.588 .96)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.461,
    cy: 4.129,
    rx: 0.602,
    ry: 0.621,
    fill: "#736438",
    stroke: "#303030",
    strokeWidth: 0.012
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.655,
    cy: 4.378,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.003
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.227,
    cy: 4.354,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.003
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.681,
    cy: 3.935,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.003
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.234,
    cy: 3.914,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.003
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.746 12.749c-.17-.347-.422-.516-.754-.502l-.116.005-.046-.08c-.162-.28-.588-.74-.828-.892-.254-.162-.627-.126-1.105.105a6.178 6.178 0 00-.577.329c-.03.02-.057.035-.06.033a1.605 1.605 0 01.124-.164c.444-.55.653-.89.87-1.422.073-.18.253-.56.33-.698l.045-.08.023.029c.012.016.176.255.363.531.37.545.467.678.565.766a.36.36 0 00.225.11c.147.012.301-.065 1.041-.52.454-.278.594-.343.738-.343a.164.164 0 01.115.036c.076.055.238.252.449.548l.103.145v.179c0 .372.043.772.128 1.194l.058.283.008.03-.059-.025a1.16 1.16 0 00-.713-.045 1.821 1.821 0 00-.766.461l-.104.103-.057-.116zm3.88-1.467a3.894 3.894 0 01-.065-.165 3.438 3.438 0 00-.436-.803 5.308 5.308 0 00-.553-.558c-.076-.064-.159-.067-.298-.056-.11.008-.147.028-.232.121-.076.083-.11.257-.306-.171-.093-.204-.163-.6-.137-.7.031-.118.126-.37.213-.469.167-.19.466-.5.705-.53l.088-.012.066.07c.02.02.122.102.223.187.247.21.458.37.976.746.66.48.915.682 1.113.887.07.072.082.09.057.083a2.137 2.137 0 00-.457-.008.545.545 0 00-.24.12c-.107.103-.295.424-.55.94-.089.181-.164.324-.168.318zM10.45 18.14c-.331-.073-.583-.404-.694-.914-.036-.166-.04-.564-.008-.689.037-.139.216-.697.27-.837l.053-.139.28.007c.321.009.53.036.789.104.396.105.749.289.993.52.093.088.104.104.097.134-.025.11-.117.354-.2.535-.335.724-.657 1.096-1.065 1.23a.98.98 0 01-.515.049z",
    fill: "#8f806b",
    stroke: "#303030",
    strokeWidth: 0.0119061,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.075 10.374c-.205-.199-.171-.247-.243-.33-.143-.166-.11-.224-.184-.454a1.71 1.71 0 01-.076-.804 1.57 1.57 0 00.007-.47c-.074-.305-.309-.535-.818-.8L10.6 7.43l.052-.088c.098-.168.224-.477.277-.678l.022-.236.007-.092c-.012.172.048-.017.172-.061.1-.083.129-.082.183-.179.008-.015.566.459.607.528.182.308.545.48 1.085.515l.138.01-.008.033a.517.517 0 00.057.254c.052.109.132.22.254.348l.1.106-.11.055c-.43.212-.734.553-.842.948-.022.078-.013.237.02.392l.032.162.053.136c.014.038.074.157.091.246.018.09.079.056-.209.558 0 0-.233.554-.24.941-.009.388-.265-.955-.265-.955z",
    fill: "#988068",
    stroke: "#303030",
    strokeWidth: 0.0119061,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.461,
    cy: 4.129,
    rx: 0.602,
    ry: 0.621,
    fill: "#736438",
    stroke: "#303030",
    strokeWidth: 0.012
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.655,
    cy: 4.378,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.003
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.227,
    cy: 4.354,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.003
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.681,
    cy: 3.935,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.003
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.234,
    cy: 3.914,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.003
  }))))), _view10 || (_view10 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_pos",
    viewBox: "2960.2000000000003 980 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    x: 2960.2000000000003,
    y: 980,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.769 192.447c-20.116-35.076-37.603-65.85-38.859-68.383-2.775-5.594-5.602-14.081-6.866-20.612-5.51-28.462 3.76-57.614 24.652-77.519 12.7-12.1 28.35-19.798 45.736-22.496 5.928-.92 18.822-.908 24.459.022 5.7.941 12.922 2.864 17.597 4.685 37.737 14.702 59.86 53.997 52.838 93.857-1.36 7.722-4.073 16.022-7.444 22.773-1.955 3.918-75.04 131.446-75.329 131.446-.116 0-16.668-28.698-36.783-63.774z",
    fill: "#c45528",
    stroke: "#88784b",
    strokeWidth: 4,
    strokeOpacity: 0.639
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.455,
    cy: 301.384,
    r: 10,
    fill: "#ebbb25",
    strokeLinecap: "round",
    transform: "matrix(5.1442 0 0 5.13752 -240.109 -1463.169)",
    stroke: "#ef8764",
    strokeWidth: 0.584
  }))), _view11 || (_view11 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_roots",
    viewBox: "0 2560 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    y: 2560,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.893 194.021c-20.634-35.825-38.572-67.253-39.861-69.841-2.847-5.714-5.747-14.382-7.044-21.052-5.651-29.069 3.859-58.843 25.288-79.172C40.304 11.596 56.356 3.736 74.193.98c6.08-.94 19.306-.928 25.089.023 5.847.96 13.255 2.924 18.05 4.784 38.712 15.016 61.404 55.15 54.202 95.858-1.396 7.888-4.179 16.365-7.636 23.26-2.007 4.002-76.975 134.251-77.272 134.251-.119 0-17.099-29.31-37.733-65.135z",
    fill: "#995f3d",
    stroke: "#753830",
    strokeWidth: 2
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.475 0 0 7.49086 -388.422 -1967.614)",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.632,
    cy: 274.373,
    r: 10,
    fill: "#995f3d",
    stroke: "#753830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.118 273.097l-7.365-3.112s-1.34 2.679-1.907 4.159c-.516 1.686.249 5.995 1.635 6.638 1.52.706 4.76-1.845 5.904-3.498.77-1.175 1.733-4.187 1.733-4.187z",
    fill: "#696969",
    stroke: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.113 280.694c1.654-.684 3.32-1.992 5.162-1.65 1.842.342 4.725.685 5.575.44.85-.244 4.441 1.174 4.441 1.174s-2.373 2.562-4.205 3.08c-1.642.464-3.249.837-4.843.489-1.512-.33-3.33-1.015-4.228-1.65-.898-.636-1.902-1.883-1.902-1.883z",
    fill: "#7d5b3e",
    stroke: "#7d532d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.08 265.015c-.236.599-2.984 6.918-2.984 6.918s-1.047 2.137-.398 3.485c1.198-.389 2.245-2.736 2.245-2.736s2.796-6.373 3.005-6.94c-.475-.28-1.26-.583-1.869-.727zm-3.569 10.894l-1.216 2.783",
    fill: "#696969",
    stroke: "#999"
  })))), _view12 || (_view12 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_save",
    viewBox: "653.4 2560 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    x: 653.4,
    y: 2560,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.83 193.848c-20.633-35.83-38.57-67.264-39.858-69.852-2.847-5.715-5.747-14.384-7.043-21.055-5.651-29.074 3.857-58.853 25.286-79.185C40.242 11.395 56.294 3.532 74.128.776c6.08-.94 19.306-.927 25.088.023 5.846.961 13.254 2.925 18.05 4.785 38.708 15.018 61.4 55.158 54.197 95.874-1.395 7.888-4.178 16.367-7.635 23.263-2.006 4.002-76.97 134.271-77.267 134.271-.119 0-17.097-29.315-37.73-65.145z",
    fill: "#453e39",
    stroke: "#000",
    strokeWidth: 2
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.43601 0 0 7.43932 10.822 9.497)",
    strokeWidth: 0.134
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.251,
    cy: 10.429,
    r: 10.134,
    fill: "#b0a292",
    stroke: "#544d46",
    strokeWidth: 0.178,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.319,
    cy: 10.319,
    r: 8.943,
    fill: "none",
    stroke: "#544d46",
    strokeWidth: 0.178,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.319,
    cy: 10.319,
    r: 6.562,
    fill: "none",
    stroke: "#544d46",
    strokeWidth: 0.178,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.387 9.497v.53m-.091-.268l1.603-.001m-.093-.263v.529M17.39 10.124v.53m-.09-.268l1.602-.002m-.093-.262v.529M17.395 10.737v.53m-.09-.268l1.602-.002m-.093-.263v.53M16.048 6.282l.288.445m-.222-.176l1.346-.87m-.22-.17l.287.443M16.4 6.82l.289.446m-.222-.176l1.345-.87m-.22-.171l.287.444M13.605 4.074l.442.291m-.274-.071l.882-1.339m-.27-.067l.441.291M9.874 3.321h.426m-1.058.002h.425m.204-1.431h.425m-1.054.003h.425m.472-.04l-.728 1.514m-.029-1.496l.746 1.46M10.419 3.312h.53m-.268.091V1.8m-.263.093h.529M11.042 3.309h.53m-.268.091V1.797m-.263.093h.529M10.652 18.759l-.425.001m1.065-.004l-.426.001m.145-1.414l-.515.001m-.089 1.473l.342-1.541m.364 1.547l-.355-1.553M10.131 17.344l-.53.001m.268-.091l.004 1.603m.263-.094l-.53.001M17.225 15.1l-.224.362m.56-.906l-.224.362m-1.124-.871l-.27.438m1.202.854l-1.127-1.105m1.505.509l-1.506-.52M16.682 13.274l-.279.45m.064-.275l1.363.844m.06-.272l-.28.45M14.35 17.705l-.364.22m.911-.551l-.365.22m-.602-1.288l-.441.266m.68 1.308l-.499-1.497m1.108 1.14l-1.103-1.15M6.523 17.81l-.357-.23m.895.577l-.358-.23m.892-1.108l-.433-.28m-.876 1.187l1.126-1.106m-.537 1.495l.548-1.496M6.864 16.344l-.445-.287m.274.069l-.869 1.347m.272.064l-.445-.287M6.344 16.013l-.446-.287m.275.069l-.869 1.347m.271.064l-.444-.287",
    fill: "none",
    stroke: "#544d46"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.513 15.37l-.21-.37m.527.925l-.21-.37m1.303-.57l-.255-.447m-1.326.646l1.51-.46m-1.168 1.078l1.178-1.073M4.501 14.237l-.262-.46m.212.187l-1.394.792m.21.183l-.26-.46M4.214 13.73l-.262-.46m.212.187l-1.394.792m.21.183l-.26-.46M3.914 13.215l-.262-.46m.211.187l-1.393.792m.21.183l-.26-.46",
    fill: "none",
    stroke: "#544d46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.32 9.969v-.426m0 1.058v-.425m-1.43-.208l.001-.425m0 1.054l.002-.425M1.854 9.7l1.512.732m-1.496.025l1.462-.742M3.318 11.259l.002-.53m.09.268l-1.603-.005m.092.264l.002-.53",
    fill: "none",
    stroke: "#544d46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.233 6.817l.223-.362m-.553.902l.223-.362M3.014 6.07l.223-.362m-.55.9l.223-.362m.213-.423l.908 1.413m-1.29-.76l1.635.13",
    fill: "none",
    stroke: "#544d46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.45 4.45l.347-.246m-.863.613l.348-.246m-.66-1.286l.347-.245m-.859.61l.347-.245M5.82 3.1l.279 1.657m-.887-1.205l1.452.762M6.873 4.134l.432-.306m-.166.23l-.925-1.31m-.161.228l.432-.305",
    fill: "none",
    stroke: "#544d46"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.307 7.092c-.804.782-.592 2.004-1.864 2.005-1.285.001-1.103-1.222-1.878-1.908-.842-.745-1.491-.798-2.297-.92a5.71 5.71 0 014.05-1.678 5.71 5.71 0 014.051 1.677c-.778.093-1.348.13-2.062.824z",
    fill: "#9f9185",
    stroke: "#544d46",
    strokeWidth: 0.142,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.555,
    cy: 10.143,
    r: 0.794,
    fill: "#9f9185",
    stroke: "#544d46",
    strokeWidth: 0.142,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.543 10.142l2.95.258 2.741.858-2.875-.181zm.128-.022l3.599-1.527 3.712-1.249-3.604 1.528z",
    fill: "#9f9185",
    stroke: "#564e47",
    strokeWidth: 0.071
  })))), _view13 || (_view13 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_stash",
    viewBox: "1306.8 2560 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    x: 1306.8,
    y: 2560,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.216 193.125c-20.889-36.283-38.742-67.502-39.673-69.377-2.127-4.278-5.56-14.576-6.646-19.935-5.862-28.919 3.688-59.279 25.038-79.594C47.923 4.249 76.992-3.938 104.97 2.245c34.111 7.539 60.67 35.453 66.558 69.956 1.18 6.912 1.401 19.297.468 26.147-1.66 12.18-5.279 21.817-13.798 36.733-20.708 36.26-71.44 124.005-71.697 124.009-.17.002-17.398-29.682-38.286-65.965z",
    fill: "#b26446",
    stroke: "#b26915",
    strokeWidth: 2
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.475 0 0 7.49086 -372.491 -570.897)",
    strokeWidth: 0.134,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.399,
    cy: 87.812,
    r: 10,
    fill: "#b26446",
    stroke: "#8a5111",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.333 89.063c.561-.61 1.422-.705 2.174-.47.692.218 1.24.881 1.418 1.647 2.595-.568 3.077-.687 5.584-1.238a7.999 7.999 0 01-6.272 7.406 7.937 7.937 0 01-8.767-4.102l5.298-1.222c-.144-.75.031-1.44.565-2.02z",
    fill: "#952927",
    stroke: "#b26915",
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.912 91.299c-.355-.446-.465-1.137-.1-1.574.364-.438 1.067-.676 1.569-.408.502.268.805.817.644 1.363l2.035 4.29-3.578 1.065z",
    fill: "#b26446",
    stroke: "#b26915",
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.179 81.43l-.28 1.801 5.027-1.415.094-1.672zM54.008 91.215l4.829-1.058s.082-.877.578-1.737c.497-.86 2.161-1.363 3.192-.975 1.176.442 1.819 1.455 1.819 1.455l5.01-1.141-2.596-5.11-2.86.794-.133 1.72-6.2 1.538-1.06-1.456-2.794.745z",
    fill: "#952927",
    stroke: "#b26915",
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.753 84.32l1.141 1.736 5.457-1.29.199-1.968zm8.297-2.082c.462-.113 1.32-.387 1.32-.387s-.392-.789-.912-1.368a8.621 8.621 0 00-1.006-.947l-1.269.386s1.716 1.78 1.866 2.316z",
    fill: "#952927",
    stroke: "#b26915",
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.983,
    cy: 90.528,
    r: 0.7,
    fill: "#b26446",
    stroke: "#b26915",
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.653,
    cy: 93.071,
    r: 0.7,
    fill: "#b26446",
    stroke: "#b26915",
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.992 85.229s.14-1.996.28-2.596c.58-.27 1.634-.527 1.634-.527s-.346 1.938-.167 2.675c-.736.19-1.016.235-1.747.448z",
    fill: "#952927",
    stroke: "#b26915",
    strokeWidth: 0.16
  })))), _view14 || (_view14 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_storage",
    viewBox: "1960.1999999999998 2560 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    x: 1960.1999999999998,
    y: 2560,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 193.898c-20.546-35.793-38.407-67.194-39.69-69.78-2.835-5.709-5.723-14.369-7.014-21.033-5.627-29.044 3.842-58.792 25.18-79.104C40.198 11.633 56.182 3.779 73.942 1.025c6.054-.938 19.224-.926 24.982.023 5.822.96 13.199 2.922 17.973 4.78 38.547 15.003 61.142 55.102 53.97 95.775-1.39 7.881-4.16 16.35-7.603 23.24-1.998 3.998-76.646 134.134-76.942 134.134-.118 0-17.025-29.286-37.572-65.079z",
    fill: "#dc7c31",
    stroke: "#5d431a",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.287,
    cy: 140.403,
    r: 10,
    fill: "#dfdfdf",
    fillOpacity: 0.302,
    stroke: "#5d431a",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    transform: "matrix(7.475 0 0 7.49086 -379.57 -966.268)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.449 32.909h85.527v103.243H43.449z",
    fill: "#9d732d",
    stroke: "#5d431a",
    strokeWidth: 3.818
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.325 40.324h32.751v64.067H50.325zm39.625.103h32.513v64.067H89.95zm6.724 25.031v9.916m-46.364 36.07h71.742v17.747H50.31zm25.377-46.115v9.915m6.277 43.06l8.746-.025",
    fill: "#c18d37",
    stroke: "#5d431a",
    strokeWidth: 3.818
  }))), _view15 || (_view15 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_marker_type--type_icon_water",
    viewBox: "2613.6 2560 653.4 980"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 653.4,
    height: 980,
    viewBox: "0 0 172.879 259.292",
    x: 2613.6,
    y: 2560,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.83 193.848c-20.633-35.83-38.57-67.264-39.858-69.852-2.847-5.715-5.747-14.384-7.043-21.055-5.651-29.074 3.857-58.853 25.286-79.185C40.242 11.395 56.294 3.532 74.128.776c6.08-.94 19.306-.927 25.088.023 5.846.961 13.254 2.925 18.05 4.785 38.708 15.018 61.4 55.158 54.197 95.874-1.395 7.888-4.178 16.367-7.635 23.263-2.006 4.002-76.97 134.271-77.267 134.271-.119 0-17.097-29.315-37.73-65.145z",
    fill: "#8f9daa",
    stroke: "#305675",
    strokeWidth: 2
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.475 0 0 7.49086 -379.404 -1169.279)",
    strokeWidth: 0.134,
    stroke: "#305675",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.423,
    cy: 167.522,
    r: 10,
    fill: "#8f9daa",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.744 165.266h8.821s1.373-.054 2.1 1.488c.465.985.331 3.704.331 3.704h2.6l-.03-2.592s-.118-1.821-1.067-3.18c-.838-1.202-1.945-2.002-3.09-2.133-.2-.022-6.234 0-8.583.017-.617.865-1.082 2.696-1.082 2.696z",
    fill: "#5d7891",
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.39 170.883s-1.716 2.6-1.73 3.454c-.024 1.461 1.05 1.897 1.697 1.883.83-.017 1.59-.492 1.606-1.844.01-.923-1.572-3.493-1.572-3.493zm-6.595-11.89l-.028 2.678 2.511-1.002.029 1.877.67.001-.039-1.87 2.786.977-.017-2.698-2.837 1.219h-.604zm3.192 3.585c-.38 1.042-.032 2.674-.032 2.674M61.247 162.595c-.38 1.042-.02 2.662-.02 2.662",
    fill: "#5d7891",
    strokeWidth: 0.16
  })))), _view16 || (_view16 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--cell_padding",
    viewBox: "4471.6 726.024 100 100"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    x: 4471.6,
    y: 726.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    fill: "#b0a292",
    stroke: "#391c44",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 75.05L100 75M0 25h100M75.05 0v100",
    fill: "none",
    stroke: "#391c44",
    strokeWidth: 0.05
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50 0v100",
    fill: "none",
    stroke: "#391c44",
    strokeWidth: 0.25
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 50h100",
    fill: "none",
    stroke: "#391c44",
    strokeWidth: 0.265
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25 0v100",
    fill: "none",
    stroke: "#391c44",
    strokeWidth: 0.1
  }))), _view17 || (_view17 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_barrel",
    viewBox: "4181.6 1188.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4181.6,
    y: 1188.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.662 -183.91)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.971,
    cy: 194.204,
    r: 10,
    fill: "#8e806b",
    stroke: "#756041",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.563 189.905v7.739s4.36 2.315 7.342 2.315c2.91 0 7.375-1.885 7.375-1.885v-8.269s-3.407-2.513-7.475-2.348c-4.068.166-7.242 2.448-7.242 2.448z",
    fill: "#907b57",
    stroke: "#7d5b3e",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.624 195.943s5.01 1.266 7.689 1.233c2.712-.033 6.88-1.398 6.88-1.398l.003-1.423s-4.682.373-6.98.422c-2.498.054-6.265-.305-7.586-.416zM55.604 191.037s4.968-1.24 7.647-1.208c2.712.033 6.93 1.366 6.93 1.366l.003 1.414s-4.658-.373-6.955-.422c-2.498-.054-6.257.305-7.578.416z",
    fill: "#906d57",
    stroke: "#7d5b3e",
    strokeWidth: 0.2
  })))), _view18 || (_view18 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_bed",
    viewBox: "4259.08 1188.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4259.08,
    y: 1188.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.423,
    cy: 167.522,
    r: 10,
    transform: "translate(-52.067 -157.175)",
    fill: "#3e467d",
    stroke: "#242949",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.613 4.65H3.546L3.53 15.528h1.125l.033-1.22h10.511l-.025 1.205h.989l.02-1.224h1.23v-1.59H4.67z",
    fill: "#e78d16",
    stroke: "#513208",
    strokeWidth: 0.271
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.325 10.17h11.559v1.935H5.325zm-.199-2.017c1.422 1.372 2.349 1.773 4.58 1.558.142-.013-.181-1.137-1.892-1.745-2.12-.752-2.688.187-2.688.187z",
    fill: "#b0b0b0",
    stroke: "#717171",
    strokeWidth: 0.265
  }))), _view19 || (_view19 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_cache",
    viewBox: "4336.5599999999995 1188.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4336.5599999999995,
    y: 1188.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.186,
    cy: 10.186,
    r: 9.829,
    fill: "#aa8481",
    stroke: "#564e47",
    strokeWidth: 0.185,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.472 13.77l1.597 1.652-.795.791-1.017-1.065-.616.613.797.825-.928.916-1.046-1.118.501-.498-.355-.386s-.362.327-.526.482c-.605-.119-.667-.654-.667-.654l7.625-7.546c-.442-.454-.708-.927-.811-1.482-.102-.55-.063-1.334.582-1.94.826-.777 2.345-.62 3.492.19 1.146.807 1.625 2.35 1.25 3.183-.376.834-1.384 1.176-2.042 1.17-.63-.005-1.133-.04-1.725-.462z",
    fill: "#819eaa",
    stroke: "#000",
    strokeWidth: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.493,
    cy: -1.2,
    rx: 2.372,
    ry: 1.544,
    transform: "matrix(.87594 .48242 -.33412 .94253 0 0)",
    fill: "#aa8481",
    stroke: "#000",
    strokeWidth: 0.101,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.795 8.41c-.732-.051-.727-.621-.727-.621M7.482 13.75c-.732-.052-.748-.726-.748-.726",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.106
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.388 15.651l2.22-2.02",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.053
  }))), _view20 || (_view20 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_clothes",
    viewBox: "4414.039999999999 1188.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4414.039999999999,
    y: 1188.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.946 -264.363)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.236,
    cy: 274.646,
    r: 10,
    fill: "#836b8e",
    stroke: "#3e457d",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.106 283.027l-7.186-11.002s-1.124-2.48-.628-2.778c.496-.298 2.315 1.852 2.315 1.852l7.132 10.772z",
    fill: "#565656",
    stroke: "#7e7e7e",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -96.832,
    cy: 262.796,
    rx: 0.488,
    ry: 2.433,
    transform: "rotate(-33.167)",
    fill: "#8456b2",
    stroke: "#7e7e7e",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.913 283.837c1.753-5.821-2.748-11.532-2.898-7.957-.15 3.574 3.02.482 3.237-.886.23-1.45 1.457-2.247 1.457-2.247",
    fill: "none",
    stroke: "#b29b56",
    strokeWidth: 0.6,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.44 272.189c2.415-1.618 3.932-1.968 4.842-1.844.785.107 2.745 1.493 4.08.928",
    fill: "none",
    stroke: "#b29b56",
    strokeWidth: 0.6
  })))), _view21 || (_view21 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_death_store",
    viewBox: "4491.519999999999 1188.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4491.519999999999,
    y: 1188.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.45 -103.822)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.739,
    cy: 114.124,
    r: 10,
    fill: "#000005",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.407 113.852l1.774-5.258 5.335 1.605-1.852 5.358z",
    fill: "#fff",
    stroke: "#888",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -48.958,
    cy: -116.491,
    rx: 0.457,
    ry: 0.474,
    transform: "rotate(174.497)",
    stroke: "#000004",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -47.03,
    cy: -117.234,
    rx: 0.457,
    ry: 0.474,
    transform: "rotate(174.497)",
    stroke: "#000004",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.384 108.418l2.315-1.216 5.543 1.567-2.082 5.612-2.243 1.15 1.869-5.476z",
    fill: "#fff",
    stroke: "#888",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -80.938,
    cy: -95.13,
    rx: 0.457,
    ry: 0.234,
    transform: "rotate(-168.955)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -78.703,
    cy: -94.911,
    rx: 0.457,
    ry: 0.234,
    transform: "rotate(-168.955)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.768 110.09l2.421-1.31",
    fill: "#000005",
    stroke: "#888",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -45.033,
    cy: -117.963,
    rx: 0.457,
    ry: 0.474,
    transform: "rotate(174.497)",
    stroke: "#000004",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.795 115.84l4.256-4.64 4.465 4.943-4.379 4.754z",
    fill: "#fff",
    stroke: "#888",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -114.106,
    cy: 60.93,
    rx: 0.668,
    ry: 0.487,
    transform: "rotate(-90.555)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -119.39,
    cy: 60.955,
    rx: 0.668,
    ry: 0.487,
    transform: "rotate(-90.555)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -116.671,
    cy: 63.373,
    rx: 0.668,
    ry: 0.487,
    transform: "rotate(-90.555)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -116.446,
    cy: 58.374,
    rx: 0.668,
    ry: 0.487,
    transform: "rotate(-90.555)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.295 111.165l4.523-.088 4.236 4.772-4.344.135z",
    fill: "#fff",
    stroke: "#888",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -103.16,
    cy: -83.745,
    rx: 0.668,
    ry: 0.487,
    transform: "rotate(-159.351)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -101.547,
    cy: -81.538,
    rx: 0.668,
    ry: 0.487,
    transform: "rotate(-159.351)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.767 116.217l4.245-.128-4.098 4.704-4.567.195z",
    fill: "#fff",
    stroke: "#888",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.816,
    cy: -136.445,
    rx: 0.489,
    ry: 0.275,
    transform: "rotate(145.24)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.986,
    cy: -135.983,
    rx: 0.489,
    ry: 0.275,
    transform: "rotate(145.24)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.093,
    cy: -135.546,
    rx: 0.489,
    ry: 0.275,
    transform: "rotate(145.24)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.608,
    cy: -134.898,
    rx: 0.489,
    ry: 0.275,
    transform: "rotate(145.24)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.506,
    cy: -135.312,
    rx: 0.489,
    ry: 0.275,
    transform: "rotate(145.24)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.852,
    cy: -134.426,
    rx: 0.489,
    ry: 0.275,
    transform: "rotate(145.24)",
    stroke: "#000",
    strokeWidth: 0.2
  })))), _view22 || (_view22 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_grass",
    viewBox: "4568.999999999998 1188.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4568.999999999998,
    y: 1188.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.423,
    cy: 167.522,
    r: 10,
    transform: "translate(-52.067 -157.175)",
    fill: "#617d3e",
    stroke: "#4b5233",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _view23 || (_view23 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_grocery",
    viewBox: "4646.479999999998 1188.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4646.479999999998,
    y: 1188.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.921 -211.127)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.291,
    cy: 221.392,
    r: 10,
    fill: "#b27a3c",
    stroke: "#8e5e59",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.98 221.373c-.209 1.5 1.076 3.063 2.48 3.812 1.403.748 3.434 1.086 5.261 1.005 2.105-.093 5.847-.701 6.408-1.005.562-.304 2.877-1.59 2.76-3.158-.117-1.566-.117-2.76-1.45-3.39-1.359-.644-4.794-1.17-6.852-1.076-1.815.082-4.093.584-5.332.959-1.24.374-3.074 1.419-3.274 2.853zm8.752-.595",
    fill: "#c97837",
    stroke: "#b06328",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.256 218.08c.455 1.888.25 3.411.042 4.51.823-.841 1.5-1.739 1.656-2.742.172-1.104.175-2.1.175-2.1zM57.378 218.94c.587 1.772.53 2.634.538 3.684.492-.644.955-1.839 1.11-2.842.172-1.104-.023-1.356-.023-1.356zM63.269 217.686c.058 2.02-.028 3.378-.484 4.56.823-.842 1.665-1.656 1.959-2.627.205-.675.365-1.984.365-1.984zm2.941.102c.058 2.02-.14 2.595-.62 4.215.897-.717 1.637-1.37 1.987-2.323.254-.69.415-1.654.415-1.654zm2.794.505c-.313 1.961-.676 2.832-1.132 4.014 1.096-.61 1.533-1.296 1.842-1.833.3-.52.593-1.799.593-1.799z",
    fill: "#f28a39",
    stroke: "#b06328",
    strokeWidth: 0.2
  })))), _view24 || (_view24 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_music",
    viewBox: "4021.6000000000004 1268.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4021.6000000000004,
    y: 1268.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-53.092 -291.064)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.455,
    cy: 301.384,
    r: 10,
    fill: "#b092ae",
    stroke: "#577190",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.241 299.697c.218.434.412.724.535 1.127.324-.124.638-.212.832-.259-.105-.427-.539-1.195-.749-1.48",
    fill: "#dbdbdb",
    stroke: "#9f9f9f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.583 306.144c-.072.519-.457 1.32-.604 1.754-.305.895-.617 1.054-1.073 1.438-.28.237-1.4.489-2.244.226-.693-.217-.878-.826-.878-.826s.276.095.42.108c.16.014.48-.036.48-.036.277-.162.368-.199.484-.438a.91.91 0 00.1-.308c.02-.13-.048-.426-.105-.58-.063-.17-.303-.363-.547-.468-.243-.104-.693-.067-.929.103-.3.216-.428.335-.552.803-.08.298-.092.795.141 1.22.569 1.033 1.695 1.28 2.991 1.1 1.093-.153 1.629-.753 1.983-1.236.298-.408.494-.932.691-1.467.221-.6.337-.988.458-1.556m-1.336-4.445c.269.67.603 2.931.663 3.635.4-.099.543-.237.835-.33-.06-.468-.11-1.204-.244-2.03-.14-.87-.244-1.109-.336-1.435m-1.768-3.49c-.141-.34-.366-.81-.474-1.121-.086-.248-.332-.895-.392-1.171-.07-.316-.1-.819.377-1.278.262-.252 1.07-.658 1.575.082.505.74.21 1.503.1 1.845-.135.416-.631 1.042-1.009 1.421-.36.363-.582.611-1.173 1.087-1.013.817-2.893 2.274-3.133 3.773-.199 1.243.242 1.872.648 2.414.407.544 1.211 1.363 3.659 1.363 2.187-.05 3.231-.794 3.878-1.54.77-.886.716-2.877-.167-3.684-1.368-1.25-3.934-.267-4.559.465-.686.803-.649 1.54-.313 2.076.337.537 1.585.836 1.666.53.088-.337-1.233-.399-.96-1.691.1-.466.535-.697.818-.798.295-.106.903-.324 1.492-.334 1.009-.017 1.573.486 1.703 1.367.118.8-.266 1.132-.799 1.741-.541.619-2.431 1.128-3.407.884-.903-.226-2.421-.466-2.582-1.943-.12-1.099 1.147-2.022 1.591-2.398.66-.558 1.988-1.551 2.7-2.402.619-.738.75-1.264.901-1.832.19-.707.046-1.752-.216-2.424-.169-.433-.557-1.058-1.669-1.052-1.354.006-1.833 1.146-1.869 1.982-.022.521.119.894.261 1.33.12.369.201.658.33 1.007.102.276.193.563.342.871",
    fill: "#dbdbdb",
    stroke: "#9f9f9f",
    strokeWidth: 0.2
  })))), _view25 || (_view25 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_pharmacy",
    viewBox: "4099.08 1268.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4099.08,
    y: 1268.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.032 -130.089)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.287,
    cy: 140.403,
    r: 10,
    fill: "#eecd90",
    stroke: "#603a16",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.602 146.68l1.718 1.427s4.525-4.14 4.483-4.603c-.427-.528-1.603-1.64-1.603-1.64-2.437 2.258-2.757 2.923-4.598 4.815z",
    fill: "#dcb874",
    stroke: "#8e806b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42.165 147.911a3.24 2.17 0 01-3.179 2.008 3.24 2.17 0 01-3.273-1.939",
    transform: "matrix(.7086 -.7056 .63976 .76858 0 0)",
    fill: "#dcb874",
    stroke: "#8e806b",
    strokeWidth: 0.165
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -63.048,
    cy: 144.779,
    rx: 3.359,
    ry: 2.07,
    transform: "matrix(.70163 -.71254 .72679 .68686 0 0)",
    fill: "#dcb874",
    stroke: "#8e806b",
    strokeWidth: 0.161
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.669 145.955l2.67-3.166",
    fill: "#8e806b",
    stroke: "#c99e44",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.92 136.714l.899 2.667 7.659-2.838-.755-2.397c-4.028.142-5.225 1.7-7.802 2.568z",
    fill: "#b29b56",
    stroke: "#8e806b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.437 136.415a4.068 2.595-22.141 01-1.21 2.86 4.068 2.595-22.141 01-3.822 1.418 4.068 2.595-22.141 01-2.591-1.45",
    fill: "#b29b56",
    stroke: "#8e806b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.133,
    cy: 149.174,
    rx: 4.123,
    ry: 2.595,
    transform: "rotate(-22.141)",
    fill: "#b29b56",
    stroke: "#8e806b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.003 136.536l5.617-2.324",
    fill: "#b29b56",
    stroke: "#988c68",
    strokeWidth: 0.8
  })))), _view26 || (_view26 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_plague",
    viewBox: "4176.5599999999995 1268.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4176.5599999999995,
    y: 1268.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.164.332a10 10 0 018.863 5.035 10 10 0 01-.157 10.192l-8.524-5.23z",
    fill: "#c8522c",
    stroke: "#777",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1.532 15.118a10 10 0 01.173-9.89A10 10 0 0110.297.325l.011 10z",
    fill: "#555",
    stroke: "#777",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.917 15.515a10 10 0 01-8.806 4.775 10 10 0 01-8.527-5.256l8.804-4.74z",
    fill: "#c4bf2c",
    stroke: "#777",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _view27 || (_view27 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_playground",
    viewBox: "4254.039999999999 1268.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4254.039999999999,
    y: 1268.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.251,
    cy: 10.429,
    r: 10.134,
    fill: "#b46858",
    stroke: "#544d46",
    strokeWidth: 0.106,
    strokeLinecap: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.319,
    cy: 10.319,
    r: 8.943,
    fill: "none",
    stroke: "#412b59",
    strokeWidth: 0.106,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M10.643 12.84c-.294-.651-.823-.487-1.248-.261-.566.3-1.323 1.99-1.636 2.312-.313.323-.622.964-1.223 1.426-.478.368-1.324-.04-1.632-.612-.194-.359-.138-1.15.457-1.857a69.88 69.88 0 001.578-1.932c.356-.457.855-.949 1.186-1.795.331-.847.96-1.65.83-2.015-.096-.273-1.274-.23-2.05.213-.713.405-1.208 1.562-1.95 1.537-.713-.024-1.45-.896-.899-1.64.553-.744.992-1.083 1.607-1.343.698-.294 1.28-.542 2.192-.648.876-.101 1.609-.121 1.968-.01.481.15 1.197.165 1.473-.183.397-.5-.424-.847-.456-1.712-.032-.866 1.014-1.844 1.888-1.845.874-.001 1.848.462 2.247.933.4.472.687 1.088.651 1.814-.036.726-.183 1.021-.746 1.321-.596.318-1.13-.337-1.583.552-.148.289.308.704.922 1.196.628.502 1.555 1.07 1.99 1.577.486.567.84 1.602.623 2.294-.218.692-1.097 1.226-1.657.597-.559-.628-.688-1.928-1.25-2.553-.5-.554-.686-.595-1.006-.127-.32.468-.559 1.278-.411 1.94.148.661.277 1.586.205 2.18-.072.594-.224 1.961-.482 2.546-.313.708-.734 1.532-1.623 1.546-.878.014-1.175-1.277-.954-1.919.176-.51.189-.79.746-1.723.293-.49.537-1.157.243-1.809z",
    fill: "none",
    stroke: "#392e3f",
    strokeWidth: 0.265
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.916 13.164c1.962.781 2.014 1.467 2.014 1.467m1.972.893c1.762-.145 2.421.79 2.421.79m-1.588-3.288c.957-1.154 1.776-.555 1.776-.555M6.866 12.059c.495-.268 1.58-1.176 2.185-.682.606.494.822.984.822.984M8.542 9.162c1.217 1.719 1.027 1.824 1.778 1.393.752-.43 1.198-.829 1.448-.579s.648.86.648.86M5.022 7.203c.517.146.977 1.9.977 1.9m10.376.945c-.182-.048-.765-.23-1.008.026-.242.256-.784 1.457-.784 1.457M8.895 8.116c.54-.178 1.2-.106 1.554-.562.354-.455.522-1.256.522-1.256",
    fill: "none",
    stroke: "#303030",
    strokeWidth: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.889 6.43c.235.754 1.352.655 1.352.655m-.628 2.323c-.12-1.115 1.005-1.484 1.005-1.484m-3.093-.466c.957.441 1.095.77.991 1.335-.104.564.227 1.173.227 1.173",
    fill: "none",
    stroke: "#303030",
    strokeWidth: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86 14.353a2.329 2.329 0 00-.383-.4 4.867 4.867 0 00-.522-.354 9.542 9.542 0 00-.855-.42 7.149 7.149 0 01.24-.3c.133-.164.34-.42.46-.572.198-.25.228-.28.314-.336a8.25 8.25 0 01.77-.458c.327-.165.515-.222.735-.222.198 0 .287.036.463.183.22.185.45.44.608.678l.083.124-.102.034a2.08 2.08 0 00-.416.199c-.163.11-.37.347-.589.676-.163.244-.244.377-.515.84a24.082 24.082 0 01-.234.397c-.004.004-.03-.026-.057-.068zm7.793-1.46c-.352-.077-.583-.395-.892-1.23l-.083-.222.202-.409c.379-.765.501-.95.67-1.009.09-.03.376-.029.528.005l.108.024.086.127c.099.146.242.427.307.605.203.55.237 1.046.096 1.41-.119.307-.416.591-.71.679a.853.853 0 01-.312.02zM6.009 8.95c-.001-.037-.182-.575-.261-.773-.148-.374-.33-.707-.47-.857a.77.77 0 01-.058-.066c0-.009.23-.134.337-.183.365-.17.973-.406 1.269-.495.598-.18 1.295-.275 2.121-.29.56-.01.602-.004 1.1.134.23.064.843-.082.903-.082.017 0-.11.252-.11.256 0 .004-.029.094-.064.2-.117.357-.317.705-.485.846-.098.083-.27.17-.424.213a5.11 5.11 0 01-.362.077c-.137.024-.29.053-.341.064l-.093.02-.055-.051a.435.435 0 00-.225-.116c-.266-.073-.712-.053-1.155.051-.48.113-.855.3-1.164.58-.082.074-.352.36-.437.462-.021.026-.026.028-.027.01z",
    fill: "#917e47",
    stroke: "#303030",
    strokeWidth: 0.10001123999999999,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.784 9.694a1.115 1.115 0 01-.572-.374c-.222-.274-.272-.61-.132-.887.077-.152.398-.544.633-.773.16-.155.38-.336.412-.336a.27.27 0 01.078.07c.22.254.452.76.66 1.435l.069.227-.088.097c-.282.313-.5.482-.7.54a.873.873 0 01-.36.001zm4.979 1.01c-.054-.015-.176-.129-.264-.245a29.02 29.02 0 01-.396-.575 52.327 52.327 0 00-.37-.541c-.024-.033-.042-.068-.04-.077.002-.008.054-.11.115-.226.213-.405.293-.625.295-.816 0-.1.004-.11.027-.117a16.798 16.798 0 01.311-.057c.594-.106.756-.172.983-.4l.125-.124.185.096c.254.131.384.22.52.356.218.216.273.418.214.77a1.97 1.97 0 00.001.566c.023.134.088.365.133.467l.025.06h-.038c-.154 0-.368.102-.864.408-.426.262-.696.413-.799.445-.088.027-.103.028-.163.01zm-3.787 5.608a1.372 1.372 0 01-.534-.218c-.18-.122-.39-.366-.45-.521-.133-.358-.009-.94.3-1.407.048-.07.232-.303.409-.516l.322-.386.104.044c.472.201.895.435 1.203.664.149.111.363.326.44.442a.594.594 0 01.069.122c0 .028-.116.19-.224.314a7.18 7.18 0 00-.295.383c-.347.48-.522.684-.752.881-.147.127-.244.18-.37.2a.551.551 0 01-.222-.002zm6.21-.219c-.428-.394-1.126-.631-1.858-.631h-.213l.09-.181c.093-.186.146-.28.287-.522.204-.346.33-.66.386-.95.044-.232.039-.529-.012-.729-.023-.09-.023-.092 0-.125.066-.092.333-.315.489-.408.314-.187.676-.226.984-.104.13.051.125.04.16.267.072.467.1.834.092 1.187-.007.26-.051.662-.143 1.287-.061.42-.166.978-.183.977a.639.639 0 01-.08-.068zm.622-9.014a2.099 2.099 0 01-.45-.137c-.146-.056-.228-.163-.424-.349l-.528-.5.038-.27a.792.792 0 00-.017-.317 1.503 1.503 0 00-.176-.386c-.063-.088-.188-.455-.224-.59-.02-.079-.04-.101-.045-.22-.011-.276.094-.568.312-.864.094-.127.367-.396.493-.485.22-.155.421-.251.652-.312a.973.973 0 01.308-.034c.427 0 .884.11 1.331.322.53.252.833.527 1.096.992.232.41.334.824.315 1.272-.021.492-.095.738-.279.935-.142.153-.408.317-.567.35-.069.014-.107.013-.596-.01-.195-.008-.285.005-.409.061a.95.95 0 00-.415.412l-.046.082-.048.077a3.122 3.122 0 01-.261-.025z",
    fill: "#917b56",
    stroke: "#303030",
    strokeWidth: 0.10001123999999999,
    strokeLinecap: "round"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.588 .96)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.461,
    cy: 4.129,
    rx: 0.602,
    ry: 0.621,
    fill: "#736438",
    stroke: "#303030",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.655,
    cy: 4.378,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.025
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.227,
    cy: 4.354,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.025
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.681,
    cy: 3.935,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.025
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.234,
    cy: 3.914,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.025
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.746 12.749c-.17-.347-.422-.516-.754-.502l-.116.005-.046-.08c-.162-.28-.588-.74-.828-.892-.254-.162-.627-.126-1.105.105a6.178 6.178 0 00-.577.329c-.03.02-.057.035-.06.033a1.605 1.605 0 01.124-.164c.444-.55.653-.89.87-1.422.073-.18.253-.56.33-.698l.045-.08.023.029c.012.016.176.255.363.531.37.545.467.678.565.766a.36.36 0 00.225.11c.147.012.301-.065 1.041-.52.454-.278.594-.343.738-.343a.164.164 0 01.115.036c.076.055.238.252.449.548l.103.145v.179c0 .372.043.772.128 1.194l.058.283.008.03-.059-.025a1.16 1.16 0 00-.713-.045 1.821 1.821 0 00-.766.461l-.104.103-.057-.116zm3.88-1.467a3.894 3.894 0 01-.065-.165 3.438 3.438 0 00-.436-.803 5.308 5.308 0 00-.553-.558c-.076-.064-.159-.067-.298-.056-.11.008-.147.028-.232.121-.076.083-.11.257-.306-.171-.093-.204-.163-.6-.137-.7.031-.118.126-.37.213-.469.167-.19.466-.5.705-.53l.088-.012.066.07c.02.02.122.102.223.187.247.21.458.37.976.746.66.48.915.682 1.113.887.07.072.082.09.057.083a2.137 2.137 0 00-.457-.008.545.545 0 00-.24.12c-.107.103-.295.424-.55.94-.089.181-.164.324-.168.318zM10.45 18.14c-.331-.073-.583-.404-.694-.914-.036-.166-.04-.564-.008-.689.037-.139.216-.697.27-.837l.053-.139.28.007c.321.009.53.036.789.104.396.105.749.289.993.52.093.088.104.104.097.134-.025.11-.117.354-.2.535-.335.724-.657 1.096-1.065 1.23a.98.98 0 01-.515.049z",
    fill: "#8f806b",
    stroke: "#303030",
    strokeWidth: 0.10001123999999999,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.075 10.374c-.205-.199-.171-.247-.243-.33-.143-.166-.11-.224-.184-.454a1.71 1.71 0 01-.076-.804 1.57 1.57 0 00.007-.47c-.074-.305-.309-.535-.818-.8L10.6 7.43l.052-.088c.098-.168.224-.477.277-.678l.022-.236.007-.092c-.012.172.048-.017.172-.061.1-.083.129-.082.183-.179.008-.015.566.459.607.528.182.308.545.48 1.085.515l.138.01-.008.033a.517.517 0 00.057.254c.052.109.132.22.254.348l.1.106-.11.055c-.43.212-.734.553-.842.948-.022.078-.013.237.02.392l.032.162.053.136c.014.038.074.157.091.246.018.09.079.056-.209.558 0 0-.233.554-.24.941-.009.388-.265-.955-.265-.955z",
    fill: "#988068",
    stroke: "#303030",
    strokeWidth: 0.10001123999999999,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.461,
    cy: 4.129,
    rx: 0.602,
    ry: 0.621,
    fill: "#736438",
    stroke: "#303030",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.655,
    cy: 4.378,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.025,
    strokeLinecap: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.227,
    cy: 4.354,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.025,
    strokeLinecap: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.681,
    cy: 3.935,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.025,
    strokeLinecap: "round"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.234,
    cy: 3.914,
    rx: 0.142,
    ry: 0.139,
    fill: "#7d5b3f",
    stroke: "#454545",
    strokeWidth: 0.025,
    strokeLinecap: "round"
  }))), _view28 || (_view28 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_roots",
    viewBox: "4331.519999999999 1268.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4331.519999999999,
    y: 1268.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-53.338 -264.044)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.632,
    cy: 274.373,
    r: 10,
    fill: "#995f3d",
    stroke: "#753830",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.118 273.097l-7.365-3.112s-1.34 2.679-1.907 4.159c-.516 1.686.249 5.995 1.635 6.638 1.52.706 4.76-1.845 5.904-3.498.77-1.175 1.733-4.187 1.733-4.187z",
    fill: "#696969",
    stroke: "#999",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.162 280.621c1.637-.654 3.285-1.906 5.11-1.578 1.824.327 4.677.655 5.519.42.842-.233 4.396 1.123 4.396 1.123s-2.349 2.451-4.162 2.947c-1.626.444-3.217.8-4.795.468-1.496-.316-3.297-.97-4.186-1.579-.888-.608-1.882-1.8-1.882-1.8z",
    fill: "#7d5b3e",
    stroke: "#7d532d",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.08 265.015c-.236.599-2.984 6.918-2.984 6.918s-1.047 2.137-.398 3.485c1.198-.389 2.245-2.736 2.245-2.736s2.796-6.373 3.005-6.94c-.475-.28-1.26-.583-1.869-.727zm-3.569 10.894l-1.216 2.783",
    fill: "#696969",
    stroke: "#999",
    strokeWidth: 0.2
  })))), _view29 || (_view29 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_save",
    viewBox: "4408.999999999998 1268.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4408.999999999998,
    y: 1268.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.251,
    cy: 10.429,
    r: 10.134,
    fill: "#b0a292",
    stroke: "#544d46",
    strokeWidth: 0.106,
    strokeLinecap: "round"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.319,
    cy: 10.319,
    r: 8.943,
    fill: "none",
    stroke: "#544d46",
    strokeWidth: 0.106,
    strokeLinecap: "round"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.319,
    cy: 10.319,
    r: 6.562,
    fill: "none",
    stroke: "#544d46",
    strokeWidth: 0.106,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M17.387 9.497v.53m-.091-.268l1.603-.001m-.093-.263v.529M17.39 10.124v.53m-.09-.268l1.602-.002m-.093-.262v.529M17.395 10.737v.53m-.09-.268l1.602-.002m-.093-.263v.53M16.048 6.282l.288.445m-.222-.176l1.346-.87m-.22-.17l.287.443M16.4 6.82l.289.446m-.222-.176l1.345-.87m-.22-.171l.287.444M13.605 4.074l.442.291m-.274-.071l.882-1.339m-.27-.067l.441.291M9.874 3.321h.426m-1.058.002h.425m.204-1.431h.425m-1.054.003h.425m.472-.04l-.728 1.514m-.029-1.496l.746 1.46M10.419 3.312h.53m-.268.091V1.8m-.263.093h.529M11.042 3.309h.53m-.268.091V1.797m-.263.093h.529M10.652 18.759l-.425.001m1.065-.004l-.426.001m.145-1.414l-.515.001m-.089 1.473l.342-1.541m.364 1.547l-.355-1.553M10.131 17.344l-.53.001m.268-.091l.004 1.603m.263-.094l-.53.001M17.225 15.1l-.224.362m.56-.906l-.224.362m-1.124-.871l-.27.438m1.202.854l-1.127-1.105m1.505.509l-1.506-.52M16.682 13.274l-.279.45m.064-.275l1.363.844m.06-.272l-.28.45M14.35 17.705l-.364.22m.911-.551l-.365.22m-.602-1.288l-.441.266m.68 1.308l-.499-1.497m1.108 1.14l-1.103-1.15M6.523 17.81l-.357-.23m.895.577l-.358-.23m.892-1.108l-.433-.28m-.876 1.187l1.126-1.106m-.537 1.495l.548-1.496M6.864 16.344l-.445-.287m.274.069l-.869 1.347m.272.064l-.445-.287M6.344 16.013l-.446-.287m.275.069l-.869 1.347m.271.064l-.444-.287M3.513 15.37l-.21-.37m.527.925l-.21-.37m1.303-.57l-.255-.447m-1.326.646l1.51-.46m-1.168 1.078l1.178-1.073M4.501 14.237l-.262-.46m.212.187l-1.394.792m.21.183l-.26-.46M4.214 13.73l-.262-.46m.212.187l-1.394.792m.21.183l-.26-.46M3.914 13.215l-.262-.46m.211.187l-1.393.792m.21.183l-.26-.46M3.32 9.969v-.426m0 1.058v-.425m-1.43-.208l.001-.425m0 1.054l.002-.425M1.854 9.7l1.512.732m-1.496.025l1.462-.742M3.318 11.259l.002-.53m.09.268l-1.603-.005m.092.264l.002-.53M4.233 6.817l.223-.362m-.553.902l.223-.362M3.014 6.07l.223-.362m-.55.9l.223-.362m.213-.423l.908 1.413m-1.29-.76l1.635.13M6.45 4.45l.347-.246m-.863.613l.348-.246m-.66-1.286l.347-.245m-.859.61l.347-.245M5.82 3.1l.279 1.657m-.887-1.205l1.452.762M6.873 4.134l.432-.306m-.166.23l-.925-1.31m-.161.228l.432-.305",
    fill: "none",
    stroke: "#544d46",
    strokeWidth: 0.185
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.307 7.092c-.804.782-.592 2.004-1.864 2.005-1.285.001-1.103-1.222-1.878-1.908-.842-.745-1.491-.798-2.297-.92a5.71 5.71 0 014.05-1.678 5.71 5.71 0 014.051 1.677c-.778.093-1.348.13-2.062.824z",
    fill: "#9f9185",
    stroke: "#544d46",
    strokeWidth: 0.265,
    strokeLinecap: "round"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.555,
    cy: 10.143,
    r: 0.794,
    fill: "#9f9185",
    stroke: "#544d46",
    strokeWidth: 0.265,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.543 10.142l2.95.258 2.741.858-2.875-.181z",
    fill: "#9f9185",
    stroke: "#564e47",
    strokeWidth: 0.185
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M10.671 10.12l3.599-1.527 3.712-1.249-3.604 1.528z",
    fill: "#9f9185",
    stroke: "#564e47",
    strokeWidth: 0.106
  }))), _view30 || (_view30 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_stash",
    viewBox: "4486.479999999998 1268.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4486.479999999998,
    y: 1268.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.001 -77.51)",
    stroke: "#b26915",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.399,
    cy: 87.812,
    r: 10,
    fill: "#b24115",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.333 89.063c.561-.61 1.422-.705 2.174-.47.692.218 1.24.881 1.418 1.647 2.595-.568 3.077-.687 5.584-1.238a7.999 7.999 0 01-6.272 7.406 7.937 7.937 0 01-8.767-4.102l5.298-1.222c-.144-.75.031-1.44.565-2.02z",
    fill: "#b21a15",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.912 91.299c-.355-.446-.465-1.137-.1-1.574.364-.438 1.067-.676 1.569-.408.502.268.805.817.644 1.363l2.035 4.29-3.578 1.065z",
    fill: "#b24115",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.179 81.43l-.28 1.801 5.027-1.415.094-1.672zM54.008 91.215l4.829-1.058s.082-.877.578-1.737c.497-.86 2.161-1.363 3.192-.975 1.176.442 1.819 1.455 1.819 1.455l5.01-1.141-2.596-5.11-2.86.794-.133 1.72-6.2 1.538-1.06-1.456-2.794.745z",
    fill: "#b21a15",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.753 84.32l1.141 1.736 5.457-1.29.199-1.968zm8.297-2.082c.462-.113 1.32-.387 1.32-.387s-.392-.789-.912-1.368a8.621 8.621 0 00-1.006-.947l-1.269.386s1.716 1.78 1.866 2.316z",
    fill: "#b21a15",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.983,
    cy: 90.528,
    r: 0.7,
    fill: "#b24115",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.653,
    cy: 93.071,
    r: 0.7,
    fill: "#b24115",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.992 85.229s.14-1.996.28-2.596c.58-.27 1.634-.527 1.634-.527s-.346 1.938-.167 2.675c-.736.19-1.016.235-1.747.448z",
    fill: "#b21a15",
    strokeWidth: 0.2
  })))), _view31 || (_view31 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_storage",
    viewBox: "4563.959999999997 1268.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4563.959999999997,
    y: 1268.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.423,
    cy: 167.522,
    r: 10,
    transform: "translate(-52.067 -157.175)",
    fill: "#dc7c31",
    stroke: "#5d431a",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M4.186 3.718h11.927v12.699H4.186z",
    fill: "#9d732d",
    stroke: "#5d431a",
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M5.145 4.63h4.567v7.88H5.145zm5.526.013h4.534v7.88h-4.534zm.937 3.079v1.22m-6.465 4.436h10.005v2.183H5.143zm3.539-5.672v1.22m.875 5.296l1.22-.003",
    fill: "#c18d37",
    stroke: "#5d431a",
    strokeWidth: 0.5
  }))), _view32 || (_view32 = /*#__PURE__*/React.createElement("view", {
    id: "icons--map_obj_type--type_icon_water",
    viewBox: "4641.439999999997 1268.5439999999999 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4641.439999999997,
    y: 1268.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.067 -157.175)",
    stroke: "#305675",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.423,
    cy: 167.522,
    r: 10,
    fill: "#8f9daa",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.835 165.303l8.73-.038s1.373-.053 2.1 1.489c.465.985.331 3.704.331 3.704h2.6l-.03-2.592s-.118-1.821-1.067-3.18c-.838-1.202-1.945-2.002-3.09-2.133-.2-.022-8.583.017-8.583.017zm12.555 5.58s-1.716 2.6-1.73 3.454c-.024 1.461 1.05 1.897 1.697 1.883.83-.017 1.59-.492 1.606-1.844.01-.923-1.572-3.493-1.572-3.493z",
    fill: "#5d7891",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.795 158.993l-.028 2.678 2.511-1.002.029 1.877.67.001-.039-1.87 2.786.977-.017-2.698-2.837 1.219h-.604zm3.192 3.585c-.38 1.042-.032 2.674-.032 2.674M61.247 162.595c-.38 1.042-.02 2.662-.02 2.662",
    fill: "#5d7891",
    strokeWidth: 0.2
  })))), _view33 || (_view33 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--calendar_holes",
    viewBox: "4715.380000000001 826.024 17 23.811"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23.811,
    viewBox: "0 0 17 6.3",
    x: 4715.380000000001,
    y: 826.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.214,
    cy: 3.15,
    r: 2.4,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.862,
    cy: 3.132,
    r: 2.4,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  }))), _view34 || (_view34 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_01",
    viewBox: "4571.6 726.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4571.6,
    y: 726.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.788,
    cy: 10.741,
    r: 10,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.205 13.86h2.046V6.795l-2.226.447v-1.14l2.214-.447h1.252v8.204h2.047v1.055H8.205z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view35 || (_view35 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_01_a",
    viewBox: "4652.860000000001 726.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4652.860000000001,
    y: 726.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M.906.865h19.809v19.749H.906z",
    fill: "#ac5736",
    stroke: "#ac5736",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.205 13.86h2.046V6.795l-2.226.447v-1.14l2.214-.447h1.252v8.204h2.047v1.055H8.205z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#7d3e41",
    stroke: "#7d3e41",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view36 || (_view36 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_02",
    viewBox: "4471.6 826.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4471.6,
    y: 826.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.829,
    cy: 10.734,
    r: 10,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.77 13.444h4.371v1.054H8.262v-1.054q.713-.738 1.941-1.978 1.234-1.247 1.55-1.606.602-.676.838-1.141.242-.472.242-.924 0-.738-.521-1.203-.515-.466-1.346-.466-.589 0-1.246.205-.651.205-1.396.62V5.686q.757-.304 1.414-.459.658-.155 1.203-.155 1.439 0 2.295.72.855.719.855 1.922 0 .57-.217 1.085-.21.509-.775 1.203-.155.18-.986 1.042-.83.856-2.344 2.4z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view37 || (_view37 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_02_a",
    viewBox: "4552.860000000001 826.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4552.860000000001,
    y: 826.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M.906.865h19.809v19.749H.906z",
    fill: "#ac5736",
    stroke: "#ac5736",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.485 14.395h4.372v1.055H7.978v-1.055q.713-.738 1.941-1.978 1.234-1.246 1.55-1.606.602-.676.838-1.14.241-.472.241-.925 0-.738-.52-1.203-.515-.465-1.346-.465-.59 0-1.247.205-.65.204-1.395.62V6.638q.757-.304 1.414-.46.657-.154 1.203-.154 1.439 0 2.294.72.856.718.856 1.922 0 .57-.217 1.085-.21.508-.775 1.203-.155.18-.986 1.042-.83.855-2.344 2.4z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#7d3e41",
    stroke: "#7d3e41",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view38 || (_view38 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_03",
    viewBox: "4634.120000000001 826.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4634.120000000001,
    y: 826.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.829,
    cy: 10.734,
    r: 10,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.674 5.033c-.397 0-.815.036-1.255.105a.5.5 0 00-.002 0c-.436.07-.896.172-1.387.309a.5.5 0 00-.367.482v1.115a.5.5 0 00.658.475 9.77 9.77 0 011.23-.33c.367-.07.705-.104 1.012-.104.56 0 .926.12 1.14.284a.5.5 0 00.007.004c.218.162.306.332.306.689 0 .345-.087.509-.293.666v.002c-.206.153-.563.266-1.111.266H9.485a.5.5 0 00-.5.5v1.029a.5.5 0 00.5.5h1.078c.607 0 1.01.134 1.278.352a.5.5 0 00.006.003c.27.216.386.459.386.887 0 .475-.128.733-.42.951a.5.5 0 00-.002.002c-.286.217-.77.364-1.49.364-.412 0-.802-.048-1.174-.141a3.841 3.841 0 01-1.011-.404.5.5 0 00-.752.431v1.21a.5.5 0 00.336.472c.458.16.905.28 1.341.36a7.03 7.03 0 001.297.126c1.23 0 2.245-.266 2.99-.86.745-.592 1.131-1.483 1.131-2.51 0-.69-.207-1.324-.623-1.821-.205-.249-.557-.323-.84-.484.227-.142.521-.207.69-.409a.5.5 0 00.002-.002c.368-.446.555-1.013.555-1.62 0-.861-.36-1.627-1.022-2.141-.663-.52-1.54-.758-2.566-.758zm0 1c.875 0 1.505.196 1.95.545a.5.5 0 00.002 0c.444.345.636.743.636 1.353 0 .417-.108.718-.326.983v.002c-.096.114-.3.162-.437.25.258-.325.517-.667.517-1.104 0-.593-.25-1.146-.707-1.488-.454-.347-1.05-.488-1.746-.488-.38 0-.778.041-1.197.12-.217.042-.468.127-.703.19V6.33c.314-.078.632-.16.912-.205a7.041 7.041 0 011.1-.092zm1.13 3.638a.5.5 0 00.154.774c-.422-.207-.842-.42-1.395-.42h-.578v-.03h.627c.474 0 .825-.173 1.191-.324zm.75 1.116c.171.101.41.15.533.298a.5.5 0 00.002.002c.261.313.39.68.39 1.18 0 .8-.241 1.32-.754 1.729-.511.407-1.281.642-2.367.642-.355 0-.724-.036-1.11-.11a.5.5 0 00-.003 0c-.275-.049-.569-.142-.862-.232v-.091c.176.065.335.162.522.209.455.113.927.17 1.416.17.85 0 1.56-.165 2.092-.567h.002c.534-.402.818-1.043.818-1.75 0-.588-.285-1.088-.68-1.48z",
    style: {
      InkscapeFontSpecification: "&quot",
      InkscapeStroke: "none"
    },
    color: "#000",
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#ac5736",
    paintOrder: "stroke markers fill"
  })), _view39 || (_view39 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_03_a",
    viewBox: "4471.6 907.284 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4471.6,
    y: 907.284,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M.906.865h19.809v19.749H.906z",
    fill: "#ac5736",
    stroke: "#ac5736",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.674 5.35c-.398 0-.816.035-1.255.105a.5.5 0 00-.002 0c-.436.07-.896.172-1.387.309a.5.5 0 00-.367.482v1.115a.5.5 0 00.658.475 9.44 9.44 0 011.23-.33c.367-.07.705-.104 1.012-.104.56 0 .926.119 1.14.283a.5.5 0 00.007.004c.218.163.306.333.306.69 0 .344-.087.509-.293.666v.002c-.206.153-.563.265-1.111.265H9.485a.5.5 0 00-.5.5v1.03a.5.5 0 00.5.5h1.078c.607 0 1.01.134 1.277.351a.5.5 0 00.006.004c.272.216.387.459.387.887 0 .475-.128.733-.42.951a.5.5 0 00-.002.002c-.286.217-.77.363-1.49.363-.412 0-.802-.047-1.174-.14a3.841 3.841 0 01-1.011-.405.5.5 0 00-.752.432v1.21a.5.5 0 00.336.472c.458.16.905.28 1.341.36a7.03 7.03 0 001.297.126c1.23 0 2.245-.266 2.99-.86.745-.592 1.131-1.483 1.131-2.511 0-.69-.208-1.323-.623-1.82-.205-.25-.557-.323-.84-.485.227-.141.521-.206.69-.408a.5.5 0 00.002-.002c.368-.446.555-1.013.555-1.621 0-.86-.36-1.626-1.022-2.14-.663-.52-1.54-.758-2.566-.758zm0 1c.875 0 1.505.196 1.95.544a.5.5 0 00.002 0c.444.346.636.744.636 1.354 0 .416-.108.718-.326.982v.002c-.096.115-.3.163-.437.25.258-.324.517-.666.517-1.103 0-.593-.25-1.146-.707-1.488-.454-.348-1.05-.489-1.746-.489-.38 0-.778.042-1.197.121-.217.042-.468.126-.703.19v-.067c.314-.078.632-.16.912-.205a7.041 7.041 0 011.1-.091zm1.13 3.638a.5.5 0 00.154.774c-.422-.207-.842-.42-1.395-.42h-.578v-.03h.627c.474 0 .825-.173 1.191-.324zm.75 1.115c.171.102.41.15.532.3a.5.5 0 00.002.001c.262.313.391.68.391 1.18 0 .799-.241 1.32-.754 1.728-.511.408-1.281.643-2.367.643-.355 0-.724-.036-1.11-.11a.5.5 0 00-.003 0c-.275-.05-.569-.143-.862-.232v-.092c.176.066.335.163.522.21.455.113.927.17 1.416.17.85 0 1.56-.165 2.092-.567h.002c.534-.402.818-1.043.818-1.75 0-.588-.285-1.088-.68-1.48z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    color: "#000",
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#7d3e41",
    stroke: "#7d3e41",
    paintOrder: "stroke markers fill",
    strokeWidth: 0.4
  })), _view40 || (_view40 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_04",
    viewBox: "4552.860000000001 907.284 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4552.860000000001,
    y: 907.284,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.829,
    cy: 10.734,
    r: 10,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 6.753l-3.163 4.942H11.3zm-.33-1.093h1.575v6.034h1.321v1.042h-1.32v2.182H11.3v-2.182H7.12v-1.21z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view41 || (_view41 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_04_a",
    viewBox: "4634.120000000001 907.284 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4634.120000000001,
    y: 907.284,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M.906.865h19.809v19.749H.906z",
    fill: "#ac5736",
    stroke: "#ac5736",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.488 7.201l-3.163 4.942h3.163zm-.329-1.091h1.575v6.033h1.321v1.042h-1.32v2.183h-1.247v-2.183h-4.18v-1.21z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#7d3e41",
    stroke: "#7d3e41",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view42 || (_view42 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_05",
    viewBox: "4021.6000000000004 1026.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4021.6000000000004,
    y: 1026.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.829,
    cy: 10.734,
    r: 10,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.377 5.781h4.918v1.054h-3.77v2.27q.272-.093.545-.136.273-.05.546-.05 1.55 0 2.456.85.905.85.905 2.3 0 1.495-.93 2.326-.93.824-2.623.824-.583 0-1.19-.099-.602-.099-1.247-.297v-1.26q.558.305 1.153.453.595.15 1.259.15 1.073 0 1.7-.565.625-.564.625-1.532 0-.967-.626-1.531-.626-.565-1.699-.565-.502 0-1.005.112-.496.111-1.017.347z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view43 || (_view43 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_05_a",
    viewBox: "4102.860000000001 1026.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4102.860000000001,
    y: 1026.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M.906.865h19.809v19.749H.906z",
    fill: "#ac5736",
    stroke: "#ac5736",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.159 6.013h4.917v1.054h-3.77v2.27q.273-.093.546-.137.273-.05.546-.05 1.55 0 2.455.85.906.85.906 2.3 0 1.495-.93 2.326-.93.825-2.624.825-.583 0-1.19-.1-.602-.098-1.247-.297v-1.259q.558.304 1.154.453.595.149 1.258.149 1.073 0 1.7-.564.626-.565.626-1.532 0-.967-.626-1.532-.627-.564-1.7-.564-.502 0-1.004.112-.496.111-1.017.347z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#7d3e41",
    stroke: "#7d3e41",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view44 || (_view44 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_06",
    viewBox: "4184.120000000001 1026.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4184.120000000001,
    y: 1026.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.829,
    cy: 10.734,
    r: 10,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.881 10.128q-.843 0-1.34.577-.49.577-.49 1.581 0 .999.49 1.582.497.576 1.34.576.843 0 1.333-.576.496-.583.496-1.582 0-1.004-.496-1.58-.49-.578-1.333-.578zm2.487-3.925v1.141q-.472-.223-.955-.341-.478-.118-.95-.118-1.24 0-1.897.837-.65.837-.744 2.53.366-.54.918-.824.552-.292 1.215-.292 1.396 0 2.202.85.812.843.812 2.3 0 1.427-.843 2.289-.844.862-2.245.862-1.606 0-2.456-1.228-.85-1.234-.85-3.572 0-2.195 1.043-3.498 1.041-1.308 2.796-1.308.472 0 .949.093.484.093 1.005.279z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view45 || (_view45 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_06_a",
    viewBox: "4265.380000000001 1026.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4265.380000000001,
    y: 1026.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M.906.865h19.809v19.749H.906z",
    fill: "#ac5736",
    stroke: "#ac5736",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.025 10.356q-.843 0-1.34.577-.49.576-.49 1.581 0 .998.49 1.581.497.577 1.34.577.844 0 1.333-.577.497-.583.497-1.581 0-1.005-.497-1.581-.49-.577-1.333-.577zm2.487-3.925v1.14q-.471-.223-.955-.34-.478-.118-.949-.118-1.24 0-1.897.837-.652.837-.745 2.53.366-.54.918-.825.552-.291 1.216-.291 1.395 0 2.201.85.812.843.812 2.3 0 1.426-.843 2.288-.843.862-2.245.862-1.606 0-2.455-1.228-.85-1.234-.85-3.572 0-2.195 1.042-3.497 1.042-1.308 2.796-1.308.472 0 .95.093.483.093 1.004.279z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#7d3e41",
    stroke: "#7d3e41",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view46 || (_view46 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_07",
    viewBox: "4346.640000000001 1026.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4346.640000000001,
    y: 1026.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.829,
    cy: 10.734,
    r: 10,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.047 6.01H14v.533l-3.361 8.725H9.33l3.163-8.204H8.047z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view47 || (_view47 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_07_a",
    viewBox: "4427.9000000000015 1026.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4427.9000000000015,
    y: 1026.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M.906.865h19.809v19.749H.906z",
    fill: "#ac5736",
    stroke: "#ac5736",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.676 6.085h5.953v.534l-3.361 8.725H8.96l3.162-8.204H7.676z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#7d3e41",
    stroke: "#7d3e41",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view48 || (_view48 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_08",
    viewBox: "4509.160000000002 1026.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4509.160000000002,
    y: 1026.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.829,
    cy: 10.734,
    r: 10,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.87 10.7q-.894 0-1.408.478-.509.478-.509 1.315t.509 1.314q.514.478 1.407.478t1.408-.478q.515-.483.515-1.314 0-.837-.515-1.315-.508-.477-1.408-.477zm-1.253-.533q-.806-.198-1.26-.75-.446-.552-.446-1.346 0-1.11.788-1.755.794-.644 2.17-.644 1.383 0 2.17.644.788.645.788 1.755 0 .794-.452 1.346-.447.552-1.247.75.906.211 1.408.825.508.614.508 1.5 0 1.346-.824 2.066-.819.72-2.35.72-1.532 0-2.357-.72-.819-.72-.819-2.065 0-.887.509-1.5.508-.615 1.414-.826zm-.46-1.978q0 .72.447 1.123.453.403 1.265.403.807 0 1.26-.403.458-.403.458-1.123t-.459-1.122q-.452-.403-1.259-.403-.812 0-1.265.403-.446.403-.446 1.122z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view49 || (_view49 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_08_a",
    viewBox: "4590.420000000002 1026.024 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4590.420000000002,
    y: 1026.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M.906.865h19.809v19.749H.906z",
    fill: "#ac5736",
    stroke: "#ac5736",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.947 10.78q-.893 0-1.408.478-.508.478-.508 1.315t.508 1.315q.515.477 1.408.477.893 0 1.408-.477.514-.484.514-1.315 0-.837-.514-1.315-.509-.477-1.408-.477zm-1.253-.532q-.806-.199-1.258-.75-.447-.553-.447-1.346 0-1.11.788-1.755.793-.645 2.17-.645 1.383 0 2.17.645.788.645.788 1.755 0 .793-.453 1.345-.446.552-1.246.75.905.211 1.407.825.509.614.509 1.501 0 1.346-.825 2.065-.818.72-2.35.72t-2.356-.72q-.819-.72-.819-2.065 0-.887.508-1.5.509-.615 1.414-.825zm-.459-1.979q0 .72.447 1.123.453.403 1.265.403.806 0 1.259-.403.459-.403.459-1.123 0-.719-.46-1.122-.452-.403-1.258-.403-.812 0-1.265.403-.447.403-.447 1.122z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#7d3e41",
    stroke: "#7d3e41",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view50 || (_view50 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_09",
    viewBox: "4021.6000000000004 1107.2839999999999 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4021.6000000000004,
    y: 1107.2839999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.829,
    cy: 10.734,
    r: 10,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.449 14.862V13.72q.471.223.955.34.483.118.948.118 1.24 0 1.892-.83.657-.838.75-2.537-.36.533-.911.819-.552.285-1.222.285-1.39 0-2.201-.837-.807-.844-.807-2.3 0-1.427.844-2.289.843-.862 2.245-.862 1.606 0 2.449 1.234.85 1.228.85 3.572 0 2.189-1.042 3.497-1.036 1.303-2.79 1.303-.472 0-.956-.093-.483-.093-1.004-.28zm2.493-3.926q.843 0 1.333-.577.496-.576.496-1.58 0-1-.496-1.576-.49-.583-1.333-.583-.844 0-1.34.583-.49.577-.49 1.575 0 1.005.49 1.581.496.577 1.34.577z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view51 || (_view51 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_09_a",
    viewBox: "4102.860000000001 1107.2839999999999 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4102.860000000001,
    y: 1107.2839999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M.906.865h19.809v19.749H.906z",
    fill: "#ac5736",
    stroke: "#ac5736",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.307 15.012V13.87q.47.223.955.341.483.118.948.118 1.24 0 1.892-.831.657-.837.75-2.536-.36.533-.912.818-.551.285-1.221.285-1.39 0-2.202-.837-.806-.843-.806-2.3 0-1.427.844-2.289.843-.862 2.244-.862 1.607 0 2.45 1.234.85 1.228.85 3.572 0 2.19-1.042 3.498-1.036 1.302-2.79 1.302-.472 0-.956-.093t-1.004-.28zm2.492-3.925q.844 0 1.334-.577.496-.577.496-1.581 0-.999-.496-1.576-.49-.582-1.334-.582-.843 0-1.34.582-.489.577-.489 1.576 0 1.004.49 1.58.496.578 1.34.578z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#7d3e41",
    stroke: "#7d3e41",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view52 || (_view52 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_10",
    viewBox: "4184.120000000001 1107.2839999999999 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4184.120000000001,
    y: 1107.2839999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.829,
    cy: 10.734,
    r: 10,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.227 13.985h2.047V6.922l-2.226.447V6.228L6.26 5.78h1.253v8.204H9.56v1.054H4.227zM14.77 6.606q-.968 0-1.458.955-.483.949-.483 2.859 0 1.903.483 2.858.49.949 1.457.949.974 0 1.458-.949.49-.955.49-2.858 0-1.91-.49-2.86-.484-.954-1.458-.954zm0-.992q1.556 0 2.375 1.234.824 1.227.824 3.572 0 2.337-.824 3.571-.819 1.228-2.376 1.228-1.556 0-2.38-1.228-.82-1.234-.82-3.571 0-2.345.82-3.572.824-1.234 2.38-1.234z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view53 || (_view53 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_10_a",
    viewBox: "4265.380000000001 1107.2839999999999 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4265.380000000001,
    y: 1107.2839999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M.906.865h19.809v19.749H.906z",
    fill: "#ac5736",
    stroke: "#ac5736",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.074 14.24H6.12V7.179l-2.226.446v-1.14l2.214-.447h1.253v8.204h2.046v1.054H4.074zm10.542-7.379q-.967 0-1.457.955-.484.95-.484 2.86 0 1.903.484 2.858.49.949 1.457.949.974 0 1.457-.95.49-.954.49-2.858 0-1.91-.49-2.859-.483-.955-1.457-.955zm0-.992q1.557 0 2.375 1.234.825 1.228.825 3.572 0 2.338-.825 3.572-.818 1.228-2.375 1.228-1.556 0-2.381-1.228-.819-1.234-.819-3.572 0-2.344.819-3.572.825-1.234 2.381-1.234z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#7d3e41",
    stroke: "#7d3e41",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view54 || (_view54 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_11",
    viewBox: "4346.640000000001 1107.2839999999999 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4346.640000000001,
    y: 1107.2839999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.829,
    cy: 10.734,
    r: 10,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.557 14.083h2.046V7.019l-2.226.447V6.325l2.214-.447h1.252v8.205H9.89v1.054H4.557zm8.08 0h2.046V7.019l-2.226.447V6.325l2.214-.447h1.253v8.205h2.046v1.054h-5.333z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view55 || (_view55 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_11_a",
    viewBox: "4427.9000000000015 1107.2839999999999 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4427.9000000000015,
    y: 1107.2839999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M.906.865h19.809v19.749H.906z",
    fill: "#ac5736",
    stroke: "#ac5736",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.387 14.332h2.046V7.27l-2.226.447V6.575l2.214-.447h1.253v8.204H9.72v1.055H4.387zm8.08 0h2.046V7.27l-2.226.447V6.575l2.214-.447h1.253v8.204H17.8v1.055h-5.333z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#7d3e41",
    stroke: "#7d3e41",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view56 || (_view56 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_12",
    viewBox: "4509.160000000002 1107.2839999999999 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4509.160000000002,
    y: 1107.2839999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.829,
    cy: 10.734,
    r: 10,
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.463 14.07h2.046V7.007l-2.226.446v-1.14l2.214-.447h1.252v8.204h2.047v1.054H4.463zm8.942 0h4.372v1.054h-5.879V14.07q.713-.738 1.941-1.978 1.234-1.247 1.55-1.606.602-.676.837-1.141.242-.472.242-.924 0-.738-.52-1.203-.515-.465-1.346-.465-.59 0-1.247.204-.65.205-1.395.62V6.312q.757-.304 1.414-.459.657-.155 1.203-.155 1.439 0 2.294.72.856.719.856 1.922 0 .57-.217 1.085-.21.509-.775 1.203-.155.18-.986 1.042-.831.856-2.344 2.4z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "none",
    stroke: "#ac5736",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view57 || (_view57 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--day_12_a",
    viewBox: "4590.420000000002 1107.2839999999999 81.26 81.26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.26,
    height: 81.26,
    viewBox: "0 0 21.5 21.5",
    x: 4590.420000000002,
    y: 1107.2839999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M.906.865h19.809v19.749H.906z",
    fill: "#ac5736",
    stroke: "#ac5736",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.405 14.354h2.047V7.291l-2.226.446v-1.14l2.213-.447h1.253v8.204h2.046v1.054H4.405zm8.943 0h4.371v1.054h-5.878v-1.054q.713-.738 1.94-1.978 1.235-1.247 1.55-1.606.602-.676.838-1.141.242-.472.242-.924 0-.738-.521-1.203-.515-.465-1.346-.465-.589 0-1.246.204-.651.205-1.395.62V6.596q.756-.304 1.414-.459.657-.155 1.203-.155 1.438 0 2.294.72.856.72.856 1.922 0 .57-.217 1.085-.211.509-.775 1.203-.155.18-.986 1.042-.831.856-2.344 2.4z",
    style: {
      InkscapeFontSpecification: "&quot"
    },
    fontSize: 12.7,
    fontFamily: "Ink Free",
    fill: "#7d3e41",
    stroke: "#7d3e41",
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _view58 || (_view58 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--ham_closed",
    viewBox: "4021.6000000000004 1188.5439999999999 80 80"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 21.167 21.167",
    x: 4021.6000000000004,
    y: 1188.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91 3.761l15.443.013M2.91 17.874l15.444.013M2.92 10.863l15.443.012",
    fill: "none",
    stroke: "#391c44",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }))), _view59 || (_view59 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--ham_open",
    viewBox: "4101.6 1188.5439999999999 80 80"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 21.167 21.167",
    x: 4101.6,
    y: 1188.5439999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91 3.761l15.397 14.17M2.91 17.874L18.637 3.75",
    fill: "none",
    stroke: "#391c44",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }))), _view60 || (_view60 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--item_checked",
    viewBox: "4021.6000000000004 1346.024 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4021.6000000000004,
    y: 1346.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.953,
    height: 14.647,
    x: 3.192,
    y: 2.772,
    rx: 1.73,
    ry: 1.671,
    fill: "none",
    stroke: "#7d3e41",
    strokeWidth: 0.84,
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 11.165c.248 1.287.436 2.484.746 5.12 1.765-1.682 2.586-2.951 3.832-4.347 2.24-2.51 3.259-3.831 4.227-4.689 1.57-1.39 4.086-3.816 5.505-4.706.057-.468.057-.144.007-.543-1.992 1.042-5.788 4.01-6.849 4.932-1.144.992-3.508 2.927-5.329 5.08.242-.74.26-1.951.095-2.94-.209-1.257-.291-1.514-.553-2.203-.212-.556-.373-.722-.699-1.502-.837.11-1.368 1.279-2.287 1.78.618 1.054.973 2.302 1.305 4.018z",
    fill: "#391c44",
    stroke: "#391c44",
    strokeWidth: 0.2,
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  }))), _view61 || (_view61 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--item_unchecked",
    viewBox: "4099.08 1346.024 77.48 77.48"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 20.5 20.5",
    x: 4099.08,
    y: 1346.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13.953,
    height: 14.647,
    x: 3.192,
    y: 2.772,
    rx: 1.73,
    ry: 1.671,
    fill: "none",
    stroke: "#7d3e41",
    strokeWidth: 0.84,
    strokeLinejoin: "round",
    paintOrder: "stroke markers fill"
  }))), _view62 || (_view62 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--lang_en",
    viewBox: "0 0 1000 600"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 600,
    viewBox: "0 0 25 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    d: "M0 0h25v15H0z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3,
    d: "M0 0l25 15m0-15L0 15"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 5,
    d: "M12.5 0v15M0 7.5h25"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cf142b",
    strokeWidth: 3,
    d: "M12.5 0v15M0 7.5h25"
  }))), _view63 || (_view63 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--lang_ru",
    viewBox: "4021.6000000000004 726.024 450 300"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 300,
    viewBox: "0 0 450 300",
    x: 4021.6000000000004,
    y: 726.024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M0 0h450v300H0z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M0 0h450v200H0z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h450v100H0z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 12,
    d: "M0 0h450v300H0z"
  }))), _view64 || (_view64 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--map_menu_bg",
    viewBox: "3613.6000000000004 0 408 822"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 822,
    viewBox: "22.8 35.5 205.36 413.739",
    x: 3613.6000000000004,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cla"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#967c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dcb874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cla",
    id: "clb",
    x1: 50.504,
    x2: 265.184,
    y1: 125.958,
    y2: 125.958,
    gradientTransform: "translate(-.046 -.193)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.544,
    height: 412.543,
    x: 211.98,
    y: 39.663,
    ry: 0.061,
    fill: "#988068",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.578,
    height: 415.382,
    x: 219.908,
    y: 38.105,
    ry: 0.061,
    fill: "#907b57",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.416,
    height: 416.6,
    x: 213.98,
    y: 36.892,
    ry: 0,
    fill: "#967c5f",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.24 35.599h193.657s.152 3.637 0 5.445c-.152 1.816.12 1.003-.129 4.026-.041.505-1.311 2.39-.83 3.481.124.282.678.17.807.449.402.868-.571 1.857-.563 2.814.005.548.266 1.065.35 1.606.202 1.31.365 3.961.365 3.961s1.198 11.855-.73 20.08c-.492 2.101 1.276 4.534.343 7.192-.6 1.713.135 3.635 0 5.446-.138 1.856-.9 3.663-.83 5.524.07 1.819 1.094 3.508 1.217 5.324.113 1.652.169 10.987.19 24.062.005 3.268-1.635 4.033.01 10.445.913 3.559-2.272 7.722-.854 11.416 1.52 3.957-.102 8.194.84 12.2.97 4.117-.01 8.281-.017 12.433-.007 4.152-.745 7.317-.023 12.355.576 4.023-1.235 7.202-.027 11.907.958 3.732-.505 7.814-.515 11.334-.009 3.519.652 6.603.46 9.66-.048.757-.09 2.348-.127 4.664a1108.48 1108.48 0 00-.096 9.017c-.027 3.66-.136 8.485-.067 12.727.079 4.871.537 9.734.552 14.606.02 6.474-.644 12.938-.616 19.413.028 6.542.314 13.134.79 19.61.528 7.167-.763 14.359-.78 21.545-.017 7.264.281 14.584.686 21.781.4 7.117-.29 14.255-.627 21.375-.326 6.867 1.142 13.724.635 20.59-.478 6.465-.028 13.13-.124 19.693-.082 5.655-.498 11.16-.388 16.963.092 4.828.32 9.7.303 14.55-.013 3.569-.224 7.134-.3 10.702a613.94 613.94 0 00-.097 6.676c-.003.333-.01.403-.006 1-45.47-.013-193.483.185-193.483.185z",
    fill: "url(#clb)",
    fillRule: "evenodd",
    stroke: "#603a16",
    strokeWidth: 0.18
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.018 6.629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.031 13.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.05 20.024)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.018 26.719)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.036 33.347)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.05 40.114)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.067 46.743)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.064 53.537)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.082 60.166)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.095 66.933)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.113 73.561)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.081 80.256)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.1 86.884)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.113 93.651)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.13 100.28)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 106.973)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.018 113.602)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.031 120.369)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.049 126.998)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.017 133.692)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.035 140.32)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.049 147.088)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.067 153.716)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.063 160.51)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.081 167.14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.095 173.906)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.112 180.535)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.081 187.23)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.099 193.858)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.15 200.529)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.12 207.223)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.137 213.852)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.15 220.618)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.169 227.247)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.165 234.041)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.183 240.67)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.196 247.437)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.214 254.066)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.183 260.76)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.2 267.389)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.08 273.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.05 280.445)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.067 287.073)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.08 293.84)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.099 300.469)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.095 307.263)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.113 313.892)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.126 320.659)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.144 327.288)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.113 333.982)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.13 340.61)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.151 347.31)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.12 354.005)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.138 360.633)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.151 367.4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.17 374.029)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.165 380.823)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.183 387.452)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.197 394.219)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.215 400.848)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.183 407.542)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.105,
    cy: 40.601,
    rx: 1.914,
    ry: 1.925,
    fill: "#9f988e",
    stroke: "#000",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 42.45a6.342 1.901 0 01-6.316-1.736 6.342 1.901 0 015.217-2.038 6.342 1.901 0 017.227 1.38",
    fill: "none",
    stroke: "#62615e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672 43.757a6.342 1.901 0 01-6.316-1.735 6.342 1.901 0 015.216-2.038 6.342 1.901 0 017.228 1.38",
    fill: "none",
    stroke: "#777570",
    strokeWidth: 0.8
  }))))), _view65 || (_view65 = /*#__PURE__*/React.createElement("view", {
    id: "icons--menu_bg--under-construction-sign",
    viewBox: "4021.6000000000004 0 726.024 726.024"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 726.024,
    height: 726.024,
    viewBox: "0 0 192.094 192.094",
    x: 4021.6000000000004,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M96.118 19.34l87.519 151.587H8.6z",
    fill: "#ce9c35",
    stroke: "#ce3559",
    strokeWidth: 17.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.376,1.376",
    paintOrder: "stroke markers fill"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M77.179 57.704c-.995.025-2.125.46-2.45.737-.28.237-.056 1.24.019 1.465.075.224.629-.021.86.292.324.439.227 1.9.514 2.355.25.395 1.543.337 1.543.337s-.465 1.813-.32 2.318c.135.465 1.66.534 1.56.78-.102.248-1.948-.173-2.037.198-.09.372.034.637.075.954.041.314 1.99.045 1.712.337-.277.292-.616.876-.68 1.663-.066.83.495 1.032.743 1.674.365.943-.591 11.738-.566 13.176.025 1.442-.705 8.07-.831 9.3-.126 1.226-.617 4.506-.78 5.91-.161 1.378-.203 5.797-.102 6.853.1 1.055 1.137 2.156 1.146 3.085.006.58-1.278 1.166-1.253 1.705.03.618 1.56.565 1.7.708.132.133-.543.824-.667 1.24-.15.5-.156.986-.02 1.394.158.467.605.64.58 1.067-.025.427-1.298-.027-1.46.146-.114.12-.167.575-.227.81-.14.549 1.586.763 1.561.92-.025.157-1.26 3.01-1.284 4.56-.025 1.55.453 6.337.655 7.93.201 1.597.72 8.92 1.005 12.949.301 4.27.717 12.824.354 13.193-.331.337-.894.19-1.133.74s-.365 1.08-.088 1.327c.277.247 1.045.707.982 1.156-.063.45-.755 0-.919.045-.164.045-.189.438-.126.854s.768.213 1.096.427c.327.213-.081.689-.09 1.613-.01.942.294 1.647.17 1.886-.125.238-1.222.19-1.407.46-.153.223.124 1.54.107 2.224-.018.683.3.535.676.509.376-.026 2.82-.16 4.185-.334.65-.083.681.165.623.405-.067.273-.268.882-.036 1.612.231.73.623.73 1.282.922 0 0 .216-1.06.332-1.557.113-.491.147-1.157.743-1.438.789-.374 8.112-.258 9.9-.236 1.787.023 12.266-.167 12.655.236.447.464.76 1.86 1.341 2.29.45.337.83.11.907-.381.081-.527-.126-1.19-.29-1.718-.164-.528.3-.6.73-.624.526-.03 4.623.243 4.974-.151.29-.327.218-1.624.038-1.955-.175-.32-.511-.522-.983-.708-.409-.16-.531-.19-.629-.876-.107-.751.765-1.252.957-1.876.115-.378 0-.376-.076-.938-.075-.561.884-.267.838-.595-.05-.36-1.041-.546-1.027-.843.02-.381.75-.651.989-1.01.239-.36 0-1.506-.202-1.736-.21-.24-.724.023-.85-.146-.125-.168-.038-2.235-.013-3.404.025-1.168.107-3.841.145-5.223.038-1.382 1.03-14.273 1.14-15.693.108-1.404.471-5.253.57-7.19.1-1.95-.19-3.982-.353-4.88-.167-.911-.93-2.055-.984-2.38-.053-.326.925-.183.957-1.116.033-.962-.924-1.108-.92-1.247.003-.181.707-.485.68-1.31-.027-.833-.52-1.101-.712-1.566-.178-.428.749-3.35.97-5.226.263-2.228.248-5.584.194-7.111-.053-1.516-.728-10.837-.906-13.3-.179-2.47-.78-15.221-.718-15.76.063-.54.71-.497.875-1.22.152-.657-.705-1.653-.664-1.844.045-.207.643-.082.894-.068.155-.135.53-.576.53-.946 0-.371-.609-.16-.66-.396-.05-.236.133-.784.272-1.38.138-.595.142-.998.22-1.17.078-.172.353-.608.51-.93.157-.32.001-.955.053-1.337.05-.382.522-.12.988-.277.466-.157.555-1.84.38-2.087-.177-.247-.801-.422-1.925-.5-1.166-.081-37.273-.113-38.542-.08zm35.766 3.034c-.132.307-.205.723-.462 1.143-.667 0-29.94.08-30.377.072.092-.16.204-.745.204-.745s30.164-.514 30.635-.47zm-21.883 3.224c1.327-.023 3.953.08 5.27.096 1.318.016 6.034.078 6.852.163.836.086 1.182.186 1.584.25.402.063 1.18.087 1.18.087s.133.782.142 1.366c.01.525-.035 2.582-.053 3.662-.018 1.082.018 4.94.018 6.228 0 1.286.142 4.48.142 5.48s.107 4.639.107 5.75c0 1.113.214 9.75.038 10.706-.284 1.527-.893 2.847-1.385 3.943-.518 1.153-1.014 1.89-1.813 2.786-.685.768-1.769 1.58-2.6 2-.844.425-1.59.714-2.358.702-.366-.005-1.135-.063-1.627-.32.312-.05 1.576-.22 2.38-.584 1.048-.476 1.643-.95 2.348-1.623.705-.674 1.136-1.116 1.618-2.065.428-.844.7-1.385.795-2.001-.77.01-2.739-.033-4.195-.005-1.456.027-3.303.018-5.049.1-1.673.079-4.514.18-6.097.363-.835-1.23-1.421-2.096-1.665-3.423-.229-1.248-.114-4.533-.111-5.567.003-1.033.043-6.996.034-7.998-.01-1.007-.012-3.795-.005-4.852.008-1.064-.038-2.103-.063-3.404-.025-1.3-.107-5.096-.088-5.74.018-.657.162-2.398.063-3.1-.102-.724-.375-.72-.466-1.18-.083-.42.328-1.142.655-1.378s.699-.326 1.25-.393c.588-.072 1.943-.027 3.098-.048zm17.094.885c.933.096 1.73-.06 2.065.18.292.209.54.255.818.603.236.298.32.994.625 1.232.219.17.892-.003 1.344.007-.343.216-.837.556-.97.866-.134.31-.094.878.07 1.21.165.335.441.478.757.824-.062.365-.357 6.852-.357 8.47 0 1.617-.054 7.366-.135 9.413-.08 2.013-.098 5.04-.149 6.367-.05 1.325-.16 3.155-.193 4.348-.033 1.168.089 3.26.367 4.562.233 1.09.668 2.74.65 3.578-.017.736-.09 1.533-.015 1.937.074.4.032.612-.082.753-.222.275-.402.344-.604.427-.29.119-.685.25-.743.438a.766.766 0 00.189.753c.26.257 1.099.168 1.41.603-.437.227-1.158.57-1.164 1.558-.007 1.043.381.93.777 1.475-.466.258-1.968.399-2.102.77-.158.437-.062.715.397.96.484.257.488.588.712.794.235.215.468.106.427.429-.035.28-.324 1.264-.36 2.085-.037.839.124 1.39.004 5.238-.12 3.799-.185 3.963-.142 6.672.049 3.108.263 6.204.356 7.975.094 1.81.118 3.442.113 4.89-.004 1.338.015 2.713.029 4.133.015 1.407.1 1.91.107 2.844.009 1.188.083 2.156.1 3.126.012.79.026 1.049.11 1.252-.202.064-.68.297-.782.7-.103.41.051 1.08.454 1.192-.352.077-.453.124-.768.214-.317.09-.635.146-1.013.348.151.214.372.222.573.253.22.034.7.324.68.702-.022.414-.194.64-.665.713-.47.074-.457-.108-.815-.084-.333.022-.528.045-.749.056-.231-.014-.283-.073-.636-.09-.018-.752.021-2.036.013-2.55-.009-.513-.007-2.662-.007-3.252 0-.59.038-3.168.05-5.297.013-2.15-.215-11.222-.178-12.677.036-1.365.124-12.337-.109-13.292-.229-.943-2.155-4.882-2.989-5.898-.92-1.123-2.332-2.197-3.032-2.685-.615-.43-1.599-.84-2.079-.942-.203-.777-.379-1.287-.48-2.06-.102-.785-.203-1.172-.318-1.806.538-.252 2.167-1.058 3.398-2.033 1.231-.975 1.948-1.698 2.945-3.254.997-1.557 2.031-4.052 2.216-4.845.189-.81.048-7.174.021-9.064-.026-1.89-.07-6.767-.07-8.96 0-2.192-.27-10.282-.215-11.692.054-1.366.09-3.868.143-4.47zm-25.822.217a.602.602 0 01.3.088c.227.188.35.74.617 1.382.2.482.864 1.275.894 1.707.04.594-.088 3.988-.113 5.55-.026 1.56.088 6.897.075 8.716-.013 1.82.24 5.864.164 7.695-.076 1.83-.126 6.766-.038 7.762.08.896 1.358 2.94 2.102 4.123.763 1.21 1.318 2.312 2.79 3.514 1.474 1.202 2.781 2.165 3.2 2.358.428.196 1.332.328 1.52.564.19.236.234.714.297 1.017.052.25.144.894.025 1.084-.178.282-.294.512-.283.845.013.38.956 1.239.302 1.598-.655.36-1.325.615-2.024 1.08-.744.498-1.713 1.007-2.773 2.127-1.063 1.123-1.643 1.888-2.361 2.92-.718 1.035-1.608 2.566-1.857 3.18-.243.6-.42 1.567-.416 2.752.005 1.322.032 1.843-.019 3.1-.05 1.259-.05 1.63-.075 3.19-.025 1.562.025 2.877 0 4.696-.025 1.812 0 2.584.063 4.337.063 1.752.025 3.695-.013 4.998-.038 1.303.195 3.836.189 5.628-.006 1.8.044 2.072.126 3.213.082 1.143.126 2.044.126 3.134 0 1.09-.038 2.358-.094 2.898-.699.034-1.258.098-2.16.112-.894.014-1.85-.005-1.85-.005-.107-.18-.178-.278.187-.615.365-.337.587-.551.775-.79.19-.237.297-.526.095-.661-.208-.14-1.475.117-1.623-.28-.146-.393.328-.875.25-1.125-.071-.23-.49-.098-.566-.59-.081-.53.129-6.858.202-8.8.074-1.926.331-8.35.367-10.637.036-2.32.164-8.26.25-10.771.084-2.506.093-5.028.017-5.68-.073-.63-.445-2.27-.499-2.7-.013-.107.35-.071.54-.636a1.18 1.18 0 00.035-.703c.41-.083 1.532-.25 1.463-.622-.144-.783-2.013-.26-2.34-.438-.284-.155-.285-.39-.116-.754.17-.366.534-.938.454-1.486-.08-.548-.718-1.024-.835-1.176-.093-.12-.137-.355-.045-.422.107-.076 1.02-.033 1.174-.15.17-.13.44-.476.293-.857-.115-.3-1.094-.39-1.157-1.057-.062-.667.396-1.75.534-2.264.134-.496.366-1.938.357-3.224-.01-1.287-.116-6.228-.107-7.316.009-1.088-.348-15.704-.348-17.524 0-1.82-.409-7.992-.29-8.413.152-.533.522-1.235.692-1.753.117-.357.181-.576.092-.71-.099-.146-.674-.344-.751-.448-.104-.142.044-.358.131-.38.175-.047.602.225.829.18.227-.045.167-.347.216-.45.074-.151.166-.303.245-.472.051-.108.095-.304-.07-.407-.181-.113-.828-.154-1.106-.233-.238-.068-.383-.25-.214-.304.272-.085 1.197.002 1.298-.1.119-.086-.136-.356.162-.44.24-.065.471-.163.695-.155zm9.645 37.283c.445.014.966.09 1.023.376.1.505-.246.869-.686.824-.653-.065-.807-.598-.984-1.182 0 0 .098-.01.247-.016a6.41 6.41 0 01.4-.003zm2.039.767l1.879.04-1.185.882zm6.335 12.37c.847-.024 1.709.196 2.55 1.078 1.122 1.175 1.727 2.208 2.6 3.654.872 1.445.997 2.343 1.139 3.368.145 1.04.126 2.256.09 3.67a70.824 70.824 0 00.017 4.543c.063 1.62.062 2.738.062 4.408 0 1.652-.018 1.968 0 3.797.018 1.81-.035 3.342-.062 4.853-.027 1.486-.054 2.344-.08 4.433-.027 2.089-.035 4.318.062 4.996.114.8.196 1.104.25 1.58.103.922.4 2.407.4 3.265-.908.104-1.612.246-2.947.437-1.094.156-1.851.387-2.653.429-.62.032-1.736.08-2.252.08-.517 0-1.302.11-2.12.063-.798-.047-1.878-.2-3.07-.278-1.067-.071-2.582-.056-3.669.07-1.07.127-3.506.025-3.506.025l.003-.29c.004-.385-.023-3.15-.005-3.77.018-.62-.015-3.87.028-5.521.04-1.574-.086-3.66-.046-5.344.04-1.712.054-7.736.036-10.167-.018-2.407-.218-9.52-.125-10.31.098-.826.196-1.724.48-2.272.356-.684 1.459-1.525 2.535-2.364 1.12-.875 1.365-1.48 2.86-2.56 1.738-1.256 1.815-1.155 2.325-1.311.56.48.43.935.623 1.23.161.247.467.803.61 1.109.137.293.363.993.465 1.767.118.897.378 2.07.608 3.86.238 1.856.344 2.953.342 4.028 0 1.497-.125 3.2-.214 4.416-.114 1.56-.397 2.39-.645 3.297-.252.923-.298 1.774-.348 2.158-.635.046-4.18.056-5.274.058-.85 0-2.088-.01-2.088-.01s-.552 3.893-.783 6.212c-.232 2.32-.113 3.04-.232 4.004a57.07 57.07 0 00-.338 4.019c-.048 1.233.071 2.595-.036 3.765-.108 1.187-.26 2.82-.118 2.869.143.047.931-.171 3.982-.152 3.046.018 4.373.202 5.692.239 1.349.037 2.076.07 3.377.082.96.009 1.312.01 2.398-.083 1.111-.095 1.564-.157 2.02-.211-.016-.318-.026-1.165.064-2.512.102-1.527.142-3.27.248-5.554.08-1.7.034-2.822.072-4.813.041-2.185.137-3.883.186-4.897.056-1.156-.273-2.99-.355-3.334-.36-.003-1.013.038-2.235.097-1.637.08-2.132.1-2.924.159-.77.058-1.723.068-2.207.078.04-.27.048-.704.077-1.324.03-.65.1-2.398.14-3.202.036-.75.06-2.742.107-4.21.045-1.454-.021-4.254-.036-5.592-.015-1.372-.117-4.6-.1-4.796.286.054.492-.286.618-.41.144-.143.216-.533.228-.823.011-.27.057-.46.093-.693.036-.23.137-.683.238-1.3.278-.048.56-.084.842-.092zm3.398 24.943c.151-.003.28.058.327.155.094.193.018.794-.035 1.954-.054 1.16-.113 2.12-.261 2.356-.087.14-.577.456-.63-.052-.053-.51-.03-1.232-.053-1.891-.025-.71.069-2.226.069-2.226l.214-.163a.64.64 0 01.369-.133zm.986 22.666l2.386 1.048-17.663-.19.142-.604zm-19.105.143s.73.587.747.667c.018.08-5.84-.063-5.84-.063-.142 0-.302-.477-.302-.477z",
    fill: "#ce3559",
    paintOrder: "stroke markers fill"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSprite);
export default __webpack_public_path__ + "static/media/icon-sprite.5c1907ffe91a470c1352d0de8e4e37be.svg";
export { ForwardRef as ReactComponent };